import React from "react";

const BoxiconsInner = () => {
  return (
    <section className='section'>
      <p>
        Use the following pattern to add the Boxicons icons to anywhere in your
        project.{" "}
        <code>
          &lt;i class="bx <strong>bxl-adobe</strong>"&gt;&lt;/i&gt;
        </code>{" "}
        Replace the bold part with the below icon names. Check the{" "}
        <a href='https://boxicons.com/' target='_blank'>
          Official website
        </a>{" "}
        for more info.
      </p>
      <div className='iconslist'>
        <div className='icon'>
          <i className='bx bxl-500px' />
          <div className='label'>bxl-500px</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-adobe' />
          <div className='label'>bxl-adobe</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-airbnb' />
          <div className='label'>bxl-airbnb</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-algolia' />
          <div className='label'>bxl-algolia</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-amazon' />
          <div className='label'>bxl-amazon</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-android' />
          <div className='label'>bxl-android</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-angular' />
          <div className='label'>bxl-angular</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-apple' />
          <div className='label'>bxl-apple</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-audible' />
          <div className='label'>bxl-audible</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-aws' />
          <div className='label'>bxl-aws</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-baidu' />
          <div className='label'>bxl-baidu</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-behance' />
          <div className='label'>bxl-behance</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-bing' />
          <div className='label'>bxl-bing</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-bitcoin' />
          <div className='label'>bxl-bitcoin</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-blender' />
          <div className='label'>bxl-blender</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-blogger' />
          <div className='label'>bxl-blogger</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-bootstrap' />
          <div className='label'>bxl-bootstrap</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-chrome' />
          <div className='label'>bxl-chrome</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-codepen' />
          <div className='label'>bxl-codepen</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-c-plus-plus' />
          <div className='label'>bxl-c-plus-plus</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-creative-commons' />
          <div className='label'>bxl-creative-commons</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-css3' />
          <div className='label'>bxl-css3</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-dailymotion' />
          <div className='label'>bxl-dailymotion</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-deviantart' />
          <div className='label'>bxl-deviantart</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-dev-to' />
          <div className='label'>bxl-dev-to</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-digg' />
          <div className='label'>bxl-digg</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-digitalocean' />
          <div className='label'>bxl-digitalocean</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-discord' />
          <div className='label'>bxl-discord</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-discord-alt' />
          <div className='label'>bxl-discord-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-discourse' />
          <div className='label'>bxl-discourse</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-django' />
          <div className='label'>bxl-django</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-docker' />
          <div className='label'>bxl-docker</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-dribbble' />
          <div className='label'>bxl-dribbble</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-dropbox' />
          <div className='label'>bxl-dropbox</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-drupal' />
          <div className='label'>bxl-drupal</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-ebay' />
          <div className='label'>bxl-ebay</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-edge' />
          <div className='label'>bxl-edge</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-etsy' />
          <div className='label'>bxl-etsy</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-facebook' />
          <div className='label'>bxl-facebook</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-facebook-circle' />
          <div className='label'>bxl-facebook-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-facebook-square' />
          <div className='label'>bxl-facebook-square</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-figma' />
          <div className='label'>bxl-figma</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-firebase' />
          <div className='label'>bxl-firebase</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-firefox' />
          <div className='label'>bxl-firefox</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-flickr' />
          <div className='label'>bxl-flickr</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-flickr-square' />
          <div className='label'>bxl-flickr-square</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-flutter' />
          <div className='label'>bxl-flutter</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-foursquare' />
          <div className='label'>bxl-foursquare</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-git' />
          <div className='label'>bxl-git</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-github' />
          <div className='label'>bxl-github</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-gitlab' />
          <div className='label'>bxl-gitlab</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-google' />
          <div className='label'>bxl-google</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-google-cloud' />
          <div className='label'>bxl-google-cloud</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-google-plus' />
          <div className='label'>bxl-google-plus</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-google-plus-circle' />
          <div className='label'>bxl-google-plus-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-html5' />
          <div className='label'>bxl-html5</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-imdb' />
          <div className='label'>bxl-imdb</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-instagram' />
          <div className='label'>bxl-instagram</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-instagram-alt' />
          <div className='label'>bxl-instagram-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-internet-explorer' />
          <div className='label'>bxl-internet-explorer</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-invision' />
          <div className='label'>bxl-invision</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-javascript' />
          <div className='label'>bxl-javascript</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-joomla' />
          <div className='label'>bxl-joomla</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-jquery' />
          <div className='label'>bxl-jquery</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-jsfiddle' />
          <div className='label'>bxl-jsfiddle</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-kickstarter' />
          <div className='label'>bxl-kickstarter</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-kubernetes' />
          <div className='label'>bxl-kubernetes</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-less' />
          <div className='label'>bxl-less</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-linkedin' />
          <div className='label'>bxl-linkedin</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-linkedin-square' />
          <div className='label'>bxl-linkedin-square</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-magento' />
          <div className='label'>bxl-magento</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-mailchimp' />
          <div className='label'>bxl-mailchimp</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-markdown' />
          <div className='label'>bxl-markdown</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-mastercard' />
          <div className='label'>bxl-mastercard</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-mastodon' />
          <div className='label'>bxl-mastodon</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-medium' />
          <div className='label'>bxl-medium</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-medium-old' />
          <div className='label'>bxl-medium-old</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-medium-square' />
          <div className='label'>bxl-medium-square</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-messenger' />
          <div className='label'>bxl-messenger</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-microsoft' />
          <div className='label'>bxl-microsoft</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-microsoft-teams' />
          <div className='label'>bxl-microsoft-teams</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-nodejs' />
          <div className='label'>bxl-nodejs</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-ok-ru' />
          <div className='label'>bxl-ok-ru</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-opera' />
          <div className='label'>bxl-opera</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-patreon' />
          <div className='label'>bxl-patreon</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-paypal' />
          <div className='label'>bxl-paypal</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-periscope' />
          <div className='label'>bxl-periscope</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-php' />
          <div className='label'>bxl-php</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-pinterest' />
          <div className='label'>bxl-pinterest</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-pinterest-alt' />
          <div className='label'>bxl-pinterest-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-play-store' />
          <div className='label'>bxl-play-store</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-pocket' />
          <div className='label'>bxl-pocket</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-product-hunt' />
          <div className='label'>bxl-product-hunt</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-python' />
          <div className='label'>bxl-python</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-quora' />
          <div className='label'>bxl-quora</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-react' />
          <div className='label'>bxl-react</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-redbubble' />
          <div className='label'>bxl-redbubble</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-reddit' />
          <div className='label'>bxl-reddit</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-redux' />
          <div className='label'>bxl-redux</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-sass' />
          <div className='label'>bxl-sass</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-shopify' />
          <div className='label'>bxl-shopify</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-sketch' />
          <div className='label'>bxl-sketch</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-skype' />
          <div className='label'>bxl-skype</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-slack' />
          <div className='label'>bxl-slack</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-slack-old' />
          <div className='label'>bxl-slack-old</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-snapchat' />
          <div className='label'>bxl-snapchat</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-soundcloud' />
          <div className='label'>bxl-soundcloud</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-spotify' />
          <div className='label'>bxl-spotify</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-spring-boot' />
          <div className='label'>bxl-spring-boot</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-squarespace' />
          <div className='label'>bxl-squarespace</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-stack-overflow' />
          <div className='label'>bxl-stack-overflow</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-steam' />
          <div className='label'>bxl-steam</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-stripe' />
          <div className='label'>bxl-stripe</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-tailwind-css' />
          <div className='label'>bxl-tailwind-css</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-telegram' />
          <div className='label'>bxl-telegram</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-tiktok' />
          <div className='label'>bxl-tiktok</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-trello' />
          <div className='label'>bxl-trello</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-trip-advisor' />
          <div className='label'>bxl-trip-advisor</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-tumblr' />
          <div className='label'>bxl-tumblr</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-tux' />
          <div className='label'>bxl-tux</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-twitch' />
          <div className='label'>bxl-twitch</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-twitter' />
          <div className='label'>bxl-twitter</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-unity' />
          <div className='label'>bxl-unity</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-unsplash' />
          <div className='label'>bxl-unsplash</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-vimeo' />
          <div className='label'>bxl-vimeo</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-visa' />
          <div className='label'>bxl-visa</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-visual-studio' />
          <div className='label'>bxl-visual-studio</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-vk' />
          <div className='label'>bxl-vk</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-vuejs' />
          <div className='label'>bxl-vuejs</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-whatsapp' />
          <div className='label'>bxl-whatsapp</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-whatsapp-square' />
          <div className='label'>bxl-whatsapp-square</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-wikipedia' />
          <div className='label'>bxl-wikipedia</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-windows' />
          <div className='label'>bxl-windows</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-wix' />
          <div className='label'>bxl-wix</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-wordpress' />
          <div className='label'>bxl-wordpress</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-yahoo' />
          <div className='label'>bxl-yahoo</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-yelp' />
          <div className='label'>bxl-yelp</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-youtube' />
          <div className='label'>bxl-youtube</div>
        </div>
        <div className='icon'>
          <i className='bx bxl-zoom' />
          <div className='label'>bxl-zoom</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-add-to-queue' />
          <div className='label'>bxs-add-to-queue</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-adjust' />
          <div className='label'>bxs-adjust</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-adjust-alt' />
          <div className='label'>bxs-adjust-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-alarm' />
          <div className='label'>bxs-alarm</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-alarm-add' />
          <div className='label'>bxs-alarm-add</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-alarm-exclamation' />
          <div className='label'>bxs-alarm-exclamation</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-alarm-off' />
          <div className='label'>bxs-alarm-off</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-alarm-snooze' />
          <div className='label'>bxs-alarm-snooze</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-album' />
          <div className='label'>bxs-album</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-ambulance' />
          <div className='label'>bxs-ambulance</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-analyse' />
          <div className='label'>bxs-analyse</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-angry' />
          <div className='label'>bxs-angry</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-arch' />
          <div className='label'>bxs-arch</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-archive' />
          <div className='label'>bxs-archive</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-archive-in' />
          <div className='label'>bxs-archive-in</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-archive-out' />
          <div className='label'>bxs-archive-out</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-area' />
          <div className='label'>bxs-area</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-arrow-from-bottom' />
          <div className='label'>bxs-arrow-from-bottom</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-arrow-from-left' />
          <div className='label'>bxs-arrow-from-left</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-arrow-from-right' />
          <div className='label'>bxs-arrow-from-right</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-arrow-from-top' />
          <div className='label'>bxs-arrow-from-top</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-arrow-to-bottom' />
          <div className='label'>bxs-arrow-to-bottom</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-arrow-to-left' />
          <div className='label'>bxs-arrow-to-left</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-arrow-to-right' />
          <div className='label'>bxs-arrow-to-right</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-arrow-to-top' />
          <div className='label'>bxs-arrow-to-top</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-award' />
          <div className='label'>bxs-award</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-baby-carriage' />
          <div className='label'>bxs-baby-carriage</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-backpack' />
          <div className='label'>bxs-backpack</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-badge' />
          <div className='label'>bxs-badge</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-badge-check' />
          <div className='label'>bxs-badge-check</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-badge-dollar' />
          <div className='label'>bxs-badge-dollar</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-ball' />
          <div className='label'>bxs-ball</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-band-aid' />
          <div className='label'>bxs-band-aid</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-bank' />
          <div className='label'>bxs-bank</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-bar-chart-alt-2' />
          <div className='label'>bxs-bar-chart-alt-2</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-bar-chart-square' />
          <div className='label'>bxs-bar-chart-square</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-barcode' />
          <div className='label'>bxs-barcode</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-baseball' />
          <div className='label'>bxs-baseball</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-basket' />
          <div className='label'>bxs-basket</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-basketball' />
          <div className='label'>bxs-basketball</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-bath' />
          <div className='label'>bxs-bath</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-battery' />
          <div className='label'>bxs-battery</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-battery-charging' />
          <div className='label'>bxs-battery-charging</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-battery-full' />
          <div className='label'>bxs-battery-full</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-battery-low' />
          <div className='label'>bxs-battery-low</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-bed' />
          <div className='label'>bxs-bed</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-been-here' />
          <div className='label'>bxs-been-here</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-beer' />
          <div className='label'>bxs-beer</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-bell' />
          <div className='label'>bxs-bell</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-bell-minus' />
          <div className='label'>bxs-bell-minus</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-bell-off' />
          <div className='label'>bxs-bell-off</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-bell-plus' />
          <div className='label'>bxs-bell-plus</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-bell-ring' />
          <div className='label'>bxs-bell-ring</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-bible' />
          <div className='label'>bxs-bible</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-binoculars' />
          <div className='label'>bxs-binoculars</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-blanket' />
          <div className='label'>bxs-blanket</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-bolt' />
          <div className='label'>bxs-bolt</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-bolt-circle' />
          <div className='label'>bxs-bolt-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-bomb' />
          <div className='label'>bxs-bomb</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-bone' />
          <div className='label'>bxs-bone</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-bong' />
          <div className='label'>bxs-bong</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-book' />
          <div className='label'>bxs-book</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-book-add' />
          <div className='label'>bxs-book-add</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-book-alt' />
          <div className='label'>bxs-book-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-book-bookmark' />
          <div className='label'>bxs-book-bookmark</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-book-content' />
          <div className='label'>bxs-book-content</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-book-heart' />
          <div className='label'>bxs-book-heart</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-bookmark' />
          <div className='label'>bxs-bookmark</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-bookmark-alt' />
          <div className='label'>bxs-bookmark-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-bookmark-alt-minus' />
          <div className='label'>bxs-bookmark-alt-minus</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-bookmark-alt-plus' />
          <div className='label'>bxs-bookmark-alt-plus</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-bookmark-heart' />
          <div className='label'>bxs-bookmark-heart</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-bookmark-minus' />
          <div className='label'>bxs-bookmark-minus</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-bookmark-plus' />
          <div className='label'>bxs-bookmark-plus</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-bookmarks' />
          <div className='label'>bxs-bookmarks</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-bookmark-star' />
          <div className='label'>bxs-bookmark-star</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-book-open' />
          <div className='label'>bxs-book-open</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-book-reader' />
          <div className='label'>bxs-book-reader</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-bot' />
          <div className='label'>bxs-bot</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-bowling-ball' />
          <div className='label'>bxs-bowling-ball</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-box' />
          <div className='label'>bxs-box</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-brain' />
          <div className='label'>bxs-brain</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-briefcase' />
          <div className='label'>bxs-briefcase</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-briefcase-alt' />
          <div className='label'>bxs-briefcase-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-briefcase-alt-2' />
          <div className='label'>bxs-briefcase-alt-2</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-brightness' />
          <div className='label'>bxs-brightness</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-brightness-half' />
          <div className='label'>bxs-brightness-half</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-brush' />
          <div className='label'>bxs-brush</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-brush-alt' />
          <div className='label'>bxs-brush-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-bug' />
          <div className='label'>bxs-bug</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-bug-alt' />
          <div className='label'>bxs-bug-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-building' />
          <div className='label'>bxs-building</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-building-house' />
          <div className='label'>bxs-building-house</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-buildings' />
          <div className='label'>bxs-buildings</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-bulb' />
          <div className='label'>bxs-bulb</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-bullseye' />
          <div className='label'>bxs-bullseye</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-buoy' />
          <div className='label'>bxs-buoy</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-bus' />
          <div className='label'>bxs-bus</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-business' />
          <div className='label'>bxs-business</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-bus-school' />
          <div className='label'>bxs-bus-school</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-cabinet' />
          <div className='label'>bxs-cabinet</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-cake' />
          <div className='label'>bxs-cake</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-calculator' />
          <div className='label'>bxs-calculator</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-calendar' />
          <div className='label'>bxs-calendar</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-calendar-alt' />
          <div className='label'>bxs-calendar-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-calendar-check' />
          <div className='label'>bxs-calendar-check</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-calendar-edit' />
          <div className='label'>bxs-calendar-edit</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-calendar-event' />
          <div className='label'>bxs-calendar-event</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-calendar-exclamation' />
          <div className='label'>bxs-calendar-exclamation</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-calendar-heart' />
          <div className='label'>bxs-calendar-heart</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-calendar-minus' />
          <div className='label'>bxs-calendar-minus</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-calendar-plus' />
          <div className='label'>bxs-calendar-plus</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-calendar-star' />
          <div className='label'>bxs-calendar-star</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-calendar-week' />
          <div className='label'>bxs-calendar-week</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-calendar-x' />
          <div className='label'>bxs-calendar-x</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-camera' />
          <div className='label'>bxs-camera</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-camera-home' />
          <div className='label'>bxs-camera-home</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-camera-movie' />
          <div className='label'>bxs-camera-movie</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-camera-off' />
          <div className='label'>bxs-camera-off</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-camera-plus' />
          <div className='label'>bxs-camera-plus</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-capsule' />
          <div className='label'>bxs-capsule</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-captions' />
          <div className='label'>bxs-captions</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-car' />
          <div className='label'>bxs-car</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-car-battery' />
          <div className='label'>bxs-car-battery</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-car-crash' />
          <div className='label'>bxs-car-crash</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-card' />
          <div className='label'>bxs-card</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-caret-down-circle' />
          <div className='label'>bxs-caret-down-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-caret-down-square' />
          <div className='label'>bxs-caret-down-square</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-caret-left-circle' />
          <div className='label'>bxs-caret-left-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-caret-left-square' />
          <div className='label'>bxs-caret-left-square</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-caret-right-circle' />
          <div className='label'>bxs-caret-right-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-caret-right-square' />
          <div className='label'>bxs-caret-right-square</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-caret-up-circle' />
          <div className='label'>bxs-caret-up-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-caret-up-square' />
          <div className='label'>bxs-caret-up-square</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-car-garage' />
          <div className='label'>bxs-car-garage</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-car-mechanic' />
          <div className='label'>bxs-car-mechanic</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-carousel' />
          <div className='label'>bxs-carousel</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-cart' />
          <div className='label'>bxs-cart</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-cart-add' />
          <div className='label'>bxs-cart-add</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-cart-alt' />
          <div className='label'>bxs-cart-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-cart-download' />
          <div className='label'>bxs-cart-download</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-car-wash' />
          <div className='label'>bxs-car-wash</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-category' />
          <div className='label'>bxs-category</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-category-alt' />
          <div className='label'>bxs-category-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-cctv' />
          <div className='label'>bxs-cctv</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-certification' />
          <div className='label'>bxs-certification</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-chalkboard' />
          <div className='label'>bxs-chalkboard</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-chart' />
          <div className='label'>bxs-chart</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-chat' />
          <div className='label'>bxs-chat</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-checkbox' />
          <div className='label'>bxs-checkbox</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-checkbox-checked' />
          <div className='label'>bxs-checkbox-checked</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-checkbox-minus' />
          <div className='label'>bxs-checkbox-minus</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-check-circle' />
          <div className='label'>bxs-check-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-check-shield' />
          <div className='label'>bxs-check-shield</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-check-square' />
          <div className='label'>bxs-check-square</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-chess' />
          <div className='label'>bxs-chess</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-chevron-down' />
          <div className='label'>bxs-chevron-down</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-chevron-down-circle' />
          <div className='label'>bxs-chevron-down-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-chevron-down-square' />
          <div className='label'>bxs-chevron-down-square</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-chevron-left' />
          <div className='label'>bxs-chevron-left</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-chevron-left-circle' />
          <div className='label'>bxs-chevron-left-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-chevron-left-square' />
          <div className='label'>bxs-chevron-left-square</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-chevron-right' />
          <div className='label'>bxs-chevron-right</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-chevron-right-circle' />
          <div className='label'>bxs-chevron-right-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-chevron-right-square' />
          <div className='label'>bxs-chevron-right-square</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-chevrons-down' />
          <div className='label'>bxs-chevrons-down</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-chevrons-left' />
          <div className='label'>bxs-chevrons-left</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-chevrons-right' />
          <div className='label'>bxs-chevrons-right</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-chevrons-up' />
          <div className='label'>bxs-chevrons-up</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-chevron-up' />
          <div className='label'>bxs-chevron-up</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-chevron-up-circle' />
          <div className='label'>bxs-chevron-up-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-chevron-up-square' />
          <div className='label'>bxs-chevron-up-square</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-chip' />
          <div className='label'>bxs-chip</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-church' />
          <div className='label'>bxs-church</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-circle' />
          <div className='label'>bxs-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-city' />
          <div className='label'>bxs-city</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-clinic' />
          <div className='label'>bxs-clinic</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-cloud' />
          <div className='label'>bxs-cloud</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-cloud-download' />
          <div className='label'>bxs-cloud-download</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-cloud-lightning' />
          <div className='label'>bxs-cloud-lightning</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-cloud-rain' />
          <div className='label'>bxs-cloud-rain</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-cloud-upload' />
          <div className='label'>bxs-cloud-upload</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-coffee' />
          <div className='label'>bxs-coffee</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-coffee-alt' />
          <div className='label'>bxs-coffee-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-coffee-togo' />
          <div className='label'>bxs-coffee-togo</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-cog' />
          <div className='label'>bxs-cog</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-coin' />
          <div className='label'>bxs-coin</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-coin-stack' />
          <div className='label'>bxs-coin-stack</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-collection' />
          <div className='label'>bxs-collection</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-color-fill' />
          <div className='label'>bxs-color-fill</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-comment' />
          <div className='label'>bxs-comment</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-comment-add' />
          <div className='label'>bxs-comment-add</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-comment-check' />
          <div className='label'>bxs-comment-check</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-comment-detail' />
          <div className='label'>bxs-comment-detail</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-comment-dots' />
          <div className='label'>bxs-comment-dots</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-comment-edit' />
          <div className='label'>bxs-comment-edit</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-comment-error' />
          <div className='label'>bxs-comment-error</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-comment-minus' />
          <div className='label'>bxs-comment-minus</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-comment-x' />
          <div className='label'>bxs-comment-x</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-compass' />
          <div className='label'>bxs-compass</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-component' />
          <div className='label'>bxs-component</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-confused' />
          <div className='label'>bxs-confused</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-contact' />
          <div className='label'>bxs-contact</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-conversation' />
          <div className='label'>bxs-conversation</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-cookie' />
          <div className='label'>bxs-cookie</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-cool' />
          <div className='label'>bxs-cool</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-copy' />
          <div className='label'>bxs-copy</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-copy-alt' />
          <div className='label'>bxs-copy-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-copyright' />
          <div className='label'>bxs-copyright</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-coupon' />
          <div className='label'>bxs-coupon</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-credit-card' />
          <div className='label'>bxs-credit-card</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-credit-card-alt' />
          <div className='label'>bxs-credit-card-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-credit-card-front' />
          <div className='label'>bxs-credit-card-front</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-crop' />
          <div className='label'>bxs-crop</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-crown' />
          <div className='label'>bxs-crown</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-cube' />
          <div className='label'>bxs-cube</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-cube-alt' />
          <div className='label'>bxs-cube-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-cuboid' />
          <div className='label'>bxs-cuboid</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-customize' />
          <div className='label'>bxs-customize</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-cylinder' />
          <div className='label'>bxs-cylinder</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-dashboard' />
          <div className='label'>bxs-dashboard</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-data' />
          <div className='label'>bxs-data</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-detail' />
          <div className='label'>bxs-detail</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-devices' />
          <div className='label'>bxs-devices</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-diamond' />
          <div className='label'>bxs-diamond</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-dice-1' />
          <div className='label'>bxs-dice-1</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-dice-2' />
          <div className='label'>bxs-dice-2</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-dice-3' />
          <div className='label'>bxs-dice-3</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-dice-4' />
          <div className='label'>bxs-dice-4</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-dice-5' />
          <div className='label'>bxs-dice-5</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-dice-6' />
          <div className='label'>bxs-dice-6</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-direction-left' />
          <div className='label'>bxs-direction-left</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-direction-right' />
          <div className='label'>bxs-direction-right</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-directions' />
          <div className='label'>bxs-directions</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-disc' />
          <div className='label'>bxs-disc</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-discount' />
          <div className='label'>bxs-discount</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-dish' />
          <div className='label'>bxs-dish</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-dislike' />
          <div className='label'>bxs-dislike</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-dizzy' />
          <div className='label'>bxs-dizzy</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-dock-bottom' />
          <div className='label'>bxs-dock-bottom</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-dock-left' />
          <div className='label'>bxs-dock-left</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-dock-right' />
          <div className='label'>bxs-dock-right</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-dock-top' />
          <div className='label'>bxs-dock-top</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-dollar-circle' />
          <div className='label'>bxs-dollar-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-donate-blood' />
          <div className='label'>bxs-donate-blood</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-donate-heart' />
          <div className='label'>bxs-donate-heart</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-door-open' />
          <div className='label'>bxs-door-open</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-doughnut-chart' />
          <div className='label'>bxs-doughnut-chart</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-down-arrow' />
          <div className='label'>bxs-down-arrow</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-down-arrow-alt' />
          <div className='label'>bxs-down-arrow-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-down-arrow-circle' />
          <div className='label'>bxs-down-arrow-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-down-arrow-square' />
          <div className='label'>bxs-down-arrow-square</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-download' />
          <div className='label'>bxs-download</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-downvote' />
          <div className='label'>bxs-downvote</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-drink' />
          <div className='label'>bxs-drink</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-droplet' />
          <div className='label'>bxs-droplet</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-droplet-half' />
          <div className='label'>bxs-droplet-half</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-dryer' />
          <div className='label'>bxs-dryer</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-duplicate' />
          <div className='label'>bxs-duplicate</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-edit' />
          <div className='label'>bxs-edit</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-edit-alt' />
          <div className='label'>bxs-edit-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-edit-location' />
          <div className='label'>bxs-edit-location</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-eject' />
          <div className='label'>bxs-eject</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-envelope' />
          <div className='label'>bxs-envelope</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-envelope-open' />
          <div className='label'>bxs-envelope-open</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-eraser' />
          <div className='label'>bxs-eraser</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-error' />
          <div className='label'>bxs-error</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-error-alt' />
          <div className='label'>bxs-error-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-error-circle' />
          <div className='label'>bxs-error-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-ev-station' />
          <div className='label'>bxs-ev-station</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-exit' />
          <div className='label'>bxs-exit</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-extension' />
          <div className='label'>bxs-extension</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-eyedropper' />
          <div className='label'>bxs-eyedropper</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-face' />
          <div className='label'>bxs-face</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-face-mask' />
          <div className='label'>bxs-face-mask</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-factory' />
          <div className='label'>bxs-factory</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-fast-forward-circle' />
          <div className='label'>bxs-fast-forward-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-file' />
          <div className='label'>bxs-file</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-file-archive' />
          <div className='label'>bxs-file-archive</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-file-blank' />
          <div className='label'>bxs-file-blank</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-file-css' />
          <div className='label'>bxs-file-css</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-file-doc' />
          <div className='label'>bxs-file-doc</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-file-export' />
          <div className='label'>bxs-file-export</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-file-find' />
          <div className='label'>bxs-file-find</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-file-gif' />
          <div className='label'>bxs-file-gif</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-file-html' />
          <div className='label'>bxs-file-html</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-file-image' />
          <div className='label'>bxs-file-image</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-file-import' />
          <div className='label'>bxs-file-import</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-file-jpg' />
          <div className='label'>bxs-file-jpg</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-file-js' />
          <div className='label'>bxs-file-js</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-file-json' />
          <div className='label'>bxs-file-json</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-file-md' />
          <div className='label'>bxs-file-md</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-file-pdf' />
          <div className='label'>bxs-file-pdf</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-file-plus' />
          <div className='label'>bxs-file-plus</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-file-png' />
          <div className='label'>bxs-file-png</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-file-txt' />
          <div className='label'>bxs-file-txt</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-film' />
          <div className='label'>bxs-film</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-filter-alt' />
          <div className='label'>bxs-filter-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-first-aid' />
          <div className='label'>bxs-first-aid</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-flag' />
          <div className='label'>bxs-flag</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-flag-alt' />
          <div className='label'>bxs-flag-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-flag-checkered' />
          <div className='label'>bxs-flag-checkered</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-flame' />
          <div className='label'>bxs-flame</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-flask' />
          <div className='label'>bxs-flask</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-florist' />
          <div className='label'>bxs-florist</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-folder' />
          <div className='label'>bxs-folder</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-folder-minus' />
          <div className='label'>bxs-folder-minus</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-folder-open' />
          <div className='label'>bxs-folder-open</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-folder-plus' />
          <div className='label'>bxs-folder-plus</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-food-menu' />
          <div className='label'>bxs-food-menu</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-fridge' />
          <div className='label'>bxs-fridge</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-game' />
          <div className='label'>bxs-game</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-gas-pump' />
          <div className='label'>bxs-gas-pump</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-ghost' />
          <div className='label'>bxs-ghost</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-gift' />
          <div className='label'>bxs-gift</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-graduation' />
          <div className='label'>bxs-graduation</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-grid' />
          <div className='label'>bxs-grid</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-grid-alt' />
          <div className='label'>bxs-grid-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-group' />
          <div className='label'>bxs-group</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-guitar-amp' />
          <div className='label'>bxs-guitar-amp</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-hand' />
          <div className='label'>bxs-hand</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-hand-down' />
          <div className='label'>bxs-hand-down</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-hand-left' />
          <div className='label'>bxs-hand-left</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-hand-right' />
          <div className='label'>bxs-hand-right</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-hand-up' />
          <div className='label'>bxs-hand-up</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-happy' />
          <div className='label'>bxs-happy</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-happy-alt' />
          <div className='label'>bxs-happy-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-happy-beaming' />
          <div className='label'>bxs-happy-beaming</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-happy-heart-eyes' />
          <div className='label'>bxs-happy-heart-eyes</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-hdd' />
          <div className='label'>bxs-hdd</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-heart' />
          <div className='label'>bxs-heart</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-heart-circle' />
          <div className='label'>bxs-heart-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-heart-square' />
          <div className='label'>bxs-heart-square</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-help-circle' />
          <div className='label'>bxs-help-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-hide' />
          <div className='label'>bxs-hide</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-home' />
          <div className='label'>bxs-home</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-home-circle' />
          <div className='label'>bxs-home-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-home-heart' />
          <div className='label'>bxs-home-heart</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-home-smile' />
          <div className='label'>bxs-home-smile</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-hot' />
          <div className='label'>bxs-hot</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-hotel' />
          <div className='label'>bxs-hotel</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-hourglass' />
          <div className='label'>bxs-hourglass</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-hourglass-bottom' />
          <div className='label'>bxs-hourglass-bottom</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-hourglass-top' />
          <div className='label'>bxs-hourglass-top</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-id-card' />
          <div className='label'>bxs-id-card</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-image' />
          <div className='label'>bxs-image</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-image-add' />
          <div className='label'>bxs-image-add</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-image-alt' />
          <div className='label'>bxs-image-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-inbox' />
          <div className='label'>bxs-inbox</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-info-circle' />
          <div className='label'>bxs-info-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-info-square' />
          <div className='label'>bxs-info-square</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-institution' />
          <div className='label'>bxs-institution</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-joystick' />
          <div className='label'>bxs-joystick</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-joystick-alt' />
          <div className='label'>bxs-joystick-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-joystick-button' />
          <div className='label'>bxs-joystick-button</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-key' />
          <div className='label'>bxs-key</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-keyboard' />
          <div className='label'>bxs-keyboard</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-label' />
          <div className='label'>bxs-label</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-landmark' />
          <div className='label'>bxs-landmark</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-landscape' />
          <div className='label'>bxs-landscape</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-laugh' />
          <div className='label'>bxs-laugh</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-layer' />
          <div className='label'>bxs-layer</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-layer-minus' />
          <div className='label'>bxs-layer-minus</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-layer-plus' />
          <div className='label'>bxs-layer-plus</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-layout' />
          <div className='label'>bxs-layout</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-left-arrow' />
          <div className='label'>bxs-left-arrow</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-left-arrow-alt' />
          <div className='label'>bxs-left-arrow-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-left-arrow-circle' />
          <div className='label'>bxs-left-arrow-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-left-arrow-square' />
          <div className='label'>bxs-left-arrow-square</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-left-down-arrow-circle' />
          <div className='label'>bxs-left-down-arrow-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-left-top-arrow-circle' />
          <div className='label'>bxs-left-top-arrow-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-like' />
          <div className='label'>bxs-like</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-location-plus' />
          <div className='label'>bxs-location-plus</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-lock' />
          <div className='label'>bxs-lock</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-lock-alt' />
          <div className='label'>bxs-lock-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-lock-open' />
          <div className='label'>bxs-lock-open</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-lock-open-alt' />
          <div className='label'>bxs-lock-open-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-log-in' />
          <div className='label'>bxs-log-in</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-log-in-circle' />
          <div className='label'>bxs-log-in-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-log-out' />
          <div className='label'>bxs-log-out</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-log-out-circle' />
          <div className='label'>bxs-log-out-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-low-vision' />
          <div className='label'>bxs-low-vision</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-magic-wand' />
          <div className='label'>bxs-magic-wand</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-magnet' />
          <div className='label'>bxs-magnet</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-map' />
          <div className='label'>bxs-map</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-map-alt' />
          <div className='label'>bxs-map-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-map-pin' />
          <div className='label'>bxs-map-pin</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-mask' />
          <div className='label'>bxs-mask</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-medal' />
          <div className='label'>bxs-medal</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-megaphone' />
          <div className='label'>bxs-megaphone</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-meh' />
          <div className='label'>bxs-meh</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-meh-alt' />
          <div className='label'>bxs-meh-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-meh-blank' />
          <div className='label'>bxs-meh-blank</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-memory-card' />
          <div className='label'>bxs-memory-card</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-message' />
          <div className='label'>bxs-message</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-message-add' />
          <div className='label'>bxs-message-add</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-message-alt' />
          <div className='label'>bxs-message-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-message-alt-add' />
          <div className='label'>bxs-message-alt-add</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-message-alt-check' />
          <div className='label'>bxs-message-alt-check</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-message-alt-detail' />
          <div className='label'>bxs-message-alt-detail</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-message-alt-dots' />
          <div className='label'>bxs-message-alt-dots</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-message-alt-edit' />
          <div className='label'>bxs-message-alt-edit</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-message-alt-error' />
          <div className='label'>bxs-message-alt-error</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-message-alt-minus' />
          <div className='label'>bxs-message-alt-minus</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-message-alt-x' />
          <div className='label'>bxs-message-alt-x</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-message-check' />
          <div className='label'>bxs-message-check</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-message-detail' />
          <div className='label'>bxs-message-detail</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-message-dots' />
          <div className='label'>bxs-message-dots</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-message-edit' />
          <div className='label'>bxs-message-edit</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-message-error' />
          <div className='label'>bxs-message-error</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-message-minus' />
          <div className='label'>bxs-message-minus</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-message-rounded' />
          <div className='label'>bxs-message-rounded</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-message-rounded-add' />
          <div className='label'>bxs-message-rounded-add</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-message-rounded-check' />
          <div className='label'>bxs-message-rounded-check</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-message-rounded-detail' />
          <div className='label'>bxs-message-rounded-detail</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-message-rounded-dots' />
          <div className='label'>bxs-message-rounded-dots</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-message-rounded-edit' />
          <div className='label'>bxs-message-rounded-edit</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-message-rounded-error' />
          <div className='label'>bxs-message-rounded-error</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-message-rounded-minus' />
          <div className='label'>bxs-message-rounded-minus</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-message-rounded-x' />
          <div className='label'>bxs-message-rounded-x</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-message-square' />
          <div className='label'>bxs-message-square</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-message-square-add' />
          <div className='label'>bxs-message-square-add</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-message-square-check' />
          <div className='label'>bxs-message-square-check</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-message-square-detail' />
          <div className='label'>bxs-message-square-detail</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-message-square-dots' />
          <div className='label'>bxs-message-square-dots</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-message-square-edit' />
          <div className='label'>bxs-message-square-edit</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-message-square-error' />
          <div className='label'>bxs-message-square-error</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-message-square-minus' />
          <div className='label'>bxs-message-square-minus</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-message-square-x' />
          <div className='label'>bxs-message-square-x</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-message-x' />
          <div className='label'>bxs-message-x</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-meteor' />
          <div className='label'>bxs-meteor</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-microchip' />
          <div className='label'>bxs-microchip</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-microphone' />
          <div className='label'>bxs-microphone</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-microphone-alt' />
          <div className='label'>bxs-microphone-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-microphone-off' />
          <div className='label'>bxs-microphone-off</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-minus-circle' />
          <div className='label'>bxs-minus-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-minus-square' />
          <div className='label'>bxs-minus-square</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-mobile' />
          <div className='label'>bxs-mobile</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-mobile-vibration' />
          <div className='label'>bxs-mobile-vibration</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-moon' />
          <div className='label'>bxs-moon</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-mouse' />
          <div className='label'>bxs-mouse</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-mouse-alt' />
          <div className='label'>bxs-mouse-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-movie' />
          <div className='label'>bxs-movie</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-movie-play' />
          <div className='label'>bxs-movie-play</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-music' />
          <div className='label'>bxs-music</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-navigation' />
          <div className='label'>bxs-navigation</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-network-chart' />
          <div className='label'>bxs-network-chart</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-news' />
          <div className='label'>bxs-news</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-no-entry' />
          <div className='label'>bxs-no-entry</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-note' />
          <div className='label'>bxs-note</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-notepad' />
          <div className='label'>bxs-notepad</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-notification' />
          <div className='label'>bxs-notification</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-notification-off' />
          <div className='label'>bxs-notification-off</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-offer' />
          <div className='label'>bxs-offer</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-package' />
          <div className='label'>bxs-package</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-paint' />
          <div className='label'>bxs-paint</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-paint-roll' />
          <div className='label'>bxs-paint-roll</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-palette' />
          <div className='label'>bxs-palette</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-paper-plane' />
          <div className='label'>bxs-paper-plane</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-parking' />
          <div className='label'>bxs-parking</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-paste' />
          <div className='label'>bxs-paste</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-pen' />
          <div className='label'>bxs-pen</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-pencil' />
          <div className='label'>bxs-pencil</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-phone' />
          <div className='label'>bxs-phone</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-phone-call' />
          <div className='label'>bxs-phone-call</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-phone-incoming' />
          <div className='label'>bxs-phone-incoming</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-phone-off' />
          <div className='label'>bxs-phone-off</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-phone-outgoing' />
          <div className='label'>bxs-phone-outgoing</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-photo-album' />
          <div className='label'>bxs-photo-album</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-piano' />
          <div className='label'>bxs-piano</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-pie-chart' />
          <div className='label'>bxs-pie-chart</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-pie-chart-alt' />
          <div className='label'>bxs-pie-chart-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-pie-chart-alt-2' />
          <div className='label'>bxs-pie-chart-alt-2</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-pin' />
          <div className='label'>bxs-pin</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-pizza' />
          <div className='label'>bxs-pizza</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-plane' />
          <div className='label'>bxs-plane</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-plane-alt' />
          <div className='label'>bxs-plane-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-plane-land' />
          <div className='label'>bxs-plane-land</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-planet' />
          <div className='label'>bxs-planet</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-plane-take-off' />
          <div className='label'>bxs-plane-take-off</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-playlist' />
          <div className='label'>bxs-playlist</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-plug' />
          <div className='label'>bxs-plug</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-plus-circle' />
          <div className='label'>bxs-plus-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-plus-square' />
          <div className='label'>bxs-plus-square</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-pointer' />
          <div className='label'>bxs-pointer</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-polygon' />
          <div className='label'>bxs-polygon</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-printer' />
          <div className='label'>bxs-printer</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-purchase-tag' />
          <div className='label'>bxs-purchase-tag</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-purchase-tag-alt' />
          <div className='label'>bxs-purchase-tag-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-pyramid' />
          <div className='label'>bxs-pyramid</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-quote-alt-left' />
          <div className='label'>bxs-quote-alt-left</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-quote-alt-right' />
          <div className='label'>bxs-quote-alt-right</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-quote-left' />
          <div className='label'>bxs-quote-left</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-quote-right' />
          <div className='label'>bxs-quote-right</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-quote-single-left' />
          <div className='label'>bxs-quote-single-left</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-quote-single-right' />
          <div className='label'>bxs-quote-single-right</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-radiation' />
          <div className='label'>bxs-radiation</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-radio' />
          <div className='label'>bxs-radio</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-receipt' />
          <div className='label'>bxs-receipt</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-rectangle' />
          <div className='label'>bxs-rectangle</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-registered' />
          <div className='label'>bxs-registered</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-rename' />
          <div className='label'>bxs-rename</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-report' />
          <div className='label'>bxs-report</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-rewind-circle' />
          <div className='label'>bxs-rewind-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-right-arrow' />
          <div className='label'>bxs-right-arrow</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-right-arrow-alt' />
          <div className='label'>bxs-right-arrow-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-right-arrow-circle' />
          <div className='label'>bxs-right-arrow-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-right-arrow-square' />
          <div className='label'>bxs-right-arrow-square</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-right-down-arrow-circle' />
          <div className='label'>bxs-right-down-arrow-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-right-top-arrow-circle' />
          <div className='label'>bxs-right-top-arrow-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-rocket' />
          <div className='label'>bxs-rocket</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-ruler' />
          <div className='label'>bxs-ruler</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-sad' />
          <div className='label'>bxs-sad</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-save' />
          <div className='label'>bxs-save</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-school' />
          <div className='label'>bxs-school</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-search' />
          <div className='label'>bxs-search</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-search-alt-2' />
          <div className='label'>bxs-search-alt-2</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-select-multiple' />
          <div className='label'>bxs-select-multiple</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-send' />
          <div className='label'>bxs-send</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-server' />
          <div className='label'>bxs-server</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-shapes' />
          <div className='label'>bxs-shapes</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-share' />
          <div className='label'>bxs-share</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-share-alt' />
          <div className='label'>bxs-share-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-shield' />
          <div className='label'>bxs-shield</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-shield-alt-2' />
          <div className='label'>bxs-shield-alt-2</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-shield-x' />
          <div className='label'>bxs-shield-x</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-ship' />
          <div className='label'>bxs-ship</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-shocked' />
          <div className='label'>bxs-shocked</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-shopping-bag' />
          <div className='label'>bxs-shopping-bag</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-shopping-bag-alt' />
          <div className='label'>bxs-shopping-bag-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-shopping-bags' />
          <div className='label'>bxs-shopping-bags</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-show' />
          <div className='label'>bxs-show</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-skip-next-circle' />
          <div className='label'>bxs-skip-next-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-skip-previous-circle' />
          <div className='label'>bxs-skip-previous-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-skull' />
          <div className='label'>bxs-skull</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-sleepy' />
          <div className='label'>bxs-sleepy</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-slideshow' />
          <div className='label'>bxs-slideshow</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-smile' />
          <div className='label'>bxs-smile</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-sort-alt' />
          <div className='label'>bxs-sort-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-spa' />
          <div className='label'>bxs-spa</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-speaker' />
          <div className='label'>bxs-speaker</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-spray-can' />
          <div className='label'>bxs-spray-can</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-spreadsheet' />
          <div className='label'>bxs-spreadsheet</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-square' />
          <div className='label'>bxs-square</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-square-rounded' />
          <div className='label'>bxs-square-rounded</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-star' />
          <div className='label'>bxs-star</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-star-half' />
          <div className='label'>bxs-star-half</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-sticker' />
          <div className='label'>bxs-sticker</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-stopwatch' />
          <div className='label'>bxs-stopwatch</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-store' />
          <div className='label'>bxs-store</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-store-alt' />
          <div className='label'>bxs-store-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-sun' />
          <div className='label'>bxs-sun</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-tachometer' />
          <div className='label'>bxs-tachometer</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-tag' />
          <div className='label'>bxs-tag</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-tag-alt' />
          <div className='label'>bxs-tag-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-tag-x' />
          <div className='label'>bxs-tag-x</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-taxi' />
          <div className='label'>bxs-taxi</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-tennis-ball' />
          <div className='label'>bxs-tennis-ball</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-terminal' />
          <div className='label'>bxs-terminal</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-thermometer' />
          <div className='label'>bxs-thermometer</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-time' />
          <div className='label'>bxs-time</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-time-five' />
          <div className='label'>bxs-time-five</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-timer' />
          <div className='label'>bxs-timer</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-tired' />
          <div className='label'>bxs-tired</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-toggle-left' />
          <div className='label'>bxs-toggle-left</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-toggle-right' />
          <div className='label'>bxs-toggle-right</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-tone' />
          <div className='label'>bxs-tone</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-torch' />
          <div className='label'>bxs-torch</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-to-top' />
          <div className='label'>bxs-to-top</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-traffic' />
          <div className='label'>bxs-traffic</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-traffic-barrier' />
          <div className='label'>bxs-traffic-barrier</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-traffic-cone' />
          <div className='label'>bxs-traffic-cone</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-train' />
          <div className='label'>bxs-train</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-trash' />
          <div className='label'>bxs-trash</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-trash-alt' />
          <div className='label'>bxs-trash-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-tree' />
          <div className='label'>bxs-tree</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-trophy' />
          <div className='label'>bxs-trophy</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-truck' />
          <div className='label'>bxs-truck</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-t-shirt' />
          <div className='label'>bxs-t-shirt</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-tv' />
          <div className='label'>bxs-tv</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-up-arrow' />
          <div className='label'>bxs-up-arrow</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-up-arrow-alt' />
          <div className='label'>bxs-up-arrow-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-up-arrow-circle' />
          <div className='label'>bxs-up-arrow-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-up-arrow-square' />
          <div className='label'>bxs-up-arrow-square</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-upside-down' />
          <div className='label'>bxs-upside-down</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-upvote' />
          <div className='label'>bxs-upvote</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-user' />
          <div className='label'>bxs-user</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-user-account' />
          <div className='label'>bxs-user-account</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-user-badge' />
          <div className='label'>bxs-user-badge</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-user-check' />
          <div className='label'>bxs-user-check</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-user-circle' />
          <div className='label'>bxs-user-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-user-detail' />
          <div className='label'>bxs-user-detail</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-user-minus' />
          <div className='label'>bxs-user-minus</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-user-pin' />
          <div className='label'>bxs-user-pin</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-user-plus' />
          <div className='label'>bxs-user-plus</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-user-rectangle' />
          <div className='label'>bxs-user-rectangle</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-user-voice' />
          <div className='label'>bxs-user-voice</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-user-x' />
          <div className='label'>bxs-user-x</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-vector' />
          <div className='label'>bxs-vector</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-vial' />
          <div className='label'>bxs-vial</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-video' />
          <div className='label'>bxs-video</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-video-off' />
          <div className='label'>bxs-video-off</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-video-plus' />
          <div className='label'>bxs-video-plus</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-video-recording' />
          <div className='label'>bxs-video-recording</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-videos' />
          <div className='label'>bxs-videos</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-virus' />
          <div className='label'>bxs-virus</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-virus-block' />
          <div className='label'>bxs-virus-block</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-volume' />
          <div className='label'>bxs-volume</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-volume-full' />
          <div className='label'>bxs-volume-full</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-volume-low' />
          <div className='label'>bxs-volume-low</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-volume-mute' />
          <div className='label'>bxs-volume-mute</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-wallet' />
          <div className='label'>bxs-wallet</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-wallet-alt' />
          <div className='label'>bxs-wallet-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-washer' />
          <div className='label'>bxs-washer</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-watch' />
          <div className='label'>bxs-watch</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-watch-alt' />
          <div className='label'>bxs-watch-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-webcam' />
          <div className='label'>bxs-webcam</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-widget' />
          <div className='label'>bxs-widget</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-window-alt' />
          <div className='label'>bxs-window-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-wine' />
          <div className='label'>bxs-wine</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-wink-smile' />
          <div className='label'>bxs-wink-smile</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-wink-tongue' />
          <div className='label'>bxs-wink-tongue</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-wrench' />
          <div className='label'>bxs-wrench</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-x-circle' />
          <div className='label'>bxs-x-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-x-square' />
          <div className='label'>bxs-x-square</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-yin-yang' />
          <div className='label'>bxs-yin-yang</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-zap' />
          <div className='label'>bxs-zap</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-zoom-in' />
          <div className='label'>bxs-zoom-in</div>
        </div>
        <div className='icon'>
          <i className='bx bxs-zoom-out' />
          <div className='label'>bxs-zoom-out</div>
        </div>
        <div className='icon'>
          <i className='bx bx-abacus' />
          <div className='label'>bx-abacus</div>
        </div>
        <div className='icon'>
          <i className='bx bx-accessibility' />
          <div className='label'>bx-accessibility</div>
        </div>
        <div className='icon'>
          <i className='bx bx-add-to-queue' />
          <div className='label'>bx-add-to-queue</div>
        </div>
        <div className='icon'>
          <i className='bx bx-adjust' />
          <div className='label'>bx-adjust</div>
        </div>
        <div className='icon'>
          <i className='bx bx-alarm' />
          <div className='label'>bx-alarm</div>
        </div>
        <div className='icon'>
          <i className='bx bx-alarm-add' />
          <div className='label'>bx-alarm-add</div>
        </div>
        <div className='icon'>
          <i className='bx bx-alarm-exclamation' />
          <div className='label'>bx-alarm-exclamation</div>
        </div>
        <div className='icon'>
          <i className='bx bx-alarm-off' />
          <div className='label'>bx-alarm-off</div>
        </div>
        <div className='icon'>
          <i className='bx bx-alarm-snooze' />
          <div className='label'>bx-alarm-snooze</div>
        </div>
        <div className='icon'>
          <i className='bx bx-album' />
          <div className='label'>bx-album</div>
        </div>
        <div className='icon'>
          <i className='bx bx-align-justify' />
          <div className='label'>bx-align-justify</div>
        </div>
        <div className='icon'>
          <i className='bx bx-align-left' />
          <div className='label'>bx-align-left</div>
        </div>
        <div className='icon'>
          <i className='bx bx-align-middle' />
          <div className='label'>bx-align-middle</div>
        </div>
        <div className='icon'>
          <i className='bx bx-align-right' />
          <div className='label'>bx-align-right</div>
        </div>
        <div className='icon'>
          <i className='bx bx-analyse' />
          <div className='label'>bx-analyse</div>
        </div>
        <div className='icon'>
          <i className='bx bx-anchor' />
          <div className='label'>bx-anchor</div>
        </div>
        <div className='icon'>
          <i className='bx bx-angry' />
          <div className='label'>bx-angry</div>
        </div>
        <div className='icon'>
          <i className='bx bx-aperture' />
          <div className='label'>bx-aperture</div>
        </div>
        <div className='icon'>
          <i className='bx bx-arch' />
          <div className='label'>bx-arch</div>
        </div>
        <div className='icon'>
          <i className='bx bx-archive' />
          <div className='label'>bx-archive</div>
        </div>
        <div className='icon'>
          <i className='bx bx-archive-in' />
          <div className='label'>bx-archive-in</div>
        </div>
        <div className='icon'>
          <i className='bx bx-archive-out' />
          <div className='label'>bx-archive-out</div>
        </div>
        <div className='icon'>
          <i className='bx bx-area' />
          <div className='label'>bx-area</div>
        </div>
        <div className='icon'>
          <i className='bx bx-arrow-back' />
          <div className='label'>bx-arrow-back</div>
        </div>
        <div className='icon'>
          <i className='bx bx-arrow-from-bottom' />
          <div className='label'>bx-arrow-from-bottom</div>
        </div>
        <div className='icon'>
          <i className='bx bx-arrow-from-left' />
          <div className='label'>bx-arrow-from-left</div>
        </div>
        <div className='icon'>
          <i className='bx bx-arrow-from-right' />
          <div className='label'>bx-arrow-from-right</div>
        </div>
        <div className='icon'>
          <i className='bx bx-arrow-from-top' />
          <div className='label'>bx-arrow-from-top</div>
        </div>
        <div className='icon'>
          <i className='bx bx-arrow-to-bottom' />
          <div className='label'>bx-arrow-to-bottom</div>
        </div>
        <div className='icon'>
          <i className='bx bx-arrow-to-left' />
          <div className='label'>bx-arrow-to-left</div>
        </div>
        <div className='icon'>
          <i className='bx bx-arrow-to-right' />
          <div className='label'>bx-arrow-to-right</div>
        </div>
        <div className='icon'>
          <i className='bx bx-arrow-to-top' />
          <div className='label'>bx-arrow-to-top</div>
        </div>
        <div className='icon'>
          <i className='bx bx-at' />
          <div className='label'>bx-at</div>
        </div>
        <div className='icon'>
          <i className='bx bx-atom' />
          <div className='label'>bx-atom</div>
        </div>
        <div className='icon'>
          <i className='bx bx-award' />
          <div className='label'>bx-award</div>
        </div>
        <div className='icon'>
          <i className='bx bx-badge' />
          <div className='label'>bx-badge</div>
        </div>
        <div className='icon'>
          <i className='bx bx-badge-check' />
          <div className='label'>bx-badge-check</div>
        </div>
        <div className='icon'>
          <i className='bx bx-ball' />
          <div className='label'>bx-ball</div>
        </div>
        <div className='icon'>
          <i className='bx bx-band-aid' />
          <div className='label'>bx-band-aid</div>
        </div>
        <div className='icon'>
          <i className='bx bx-bar-chart' />
          <div className='label'>bx-bar-chart</div>
        </div>
        <div className='icon'>
          <i className='bx bx-bar-chart-alt' />
          <div className='label'>bx-bar-chart-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bx-bar-chart-alt-2' />
          <div className='label'>bx-bar-chart-alt-2</div>
        </div>
        <div className='icon'>
          <i className='bx bx-bar-chart-square' />
          <div className='label'>bx-bar-chart-square</div>
        </div>
        <div className='icon'>
          <i className='bx bx-barcode' />
          <div className='label'>bx-barcode</div>
        </div>
        <div className='icon'>
          <i className='bx bx-barcode-reader' />
          <div className='label'>bx-barcode-reader</div>
        </div>
        <div className='icon'>
          <i className='bx bx-baseball' />
          <div className='label'>bx-baseball</div>
        </div>
        <div className='icon'>
          <i className='bx bx-basket' />
          <div className='label'>bx-basket</div>
        </div>
        <div className='icon'>
          <i className='bx bx-basketball' />
          <div className='label'>bx-basketball</div>
        </div>
        <div className='icon'>
          <i className='bx bx-bath' />
          <div className='label'>bx-bath</div>
        </div>
        <div className='icon'>
          <i className='bx bx-battery' />
          <div className='label'>bx-battery</div>
        </div>
        <div className='icon'>
          <i className='bx bx-bed' />
          <div className='label'>bx-bed</div>
        </div>
        <div className='icon'>
          <i className='bx bx-been-here' />
          <div className='label'>bx-been-here</div>
        </div>
        <div className='icon'>
          <i className='bx bx-beer' />
          <div className='label'>bx-beer</div>
        </div>
        <div className='icon'>
          <i className='bx bx-bell' />
          <div className='label'>bx-bell</div>
        </div>
        <div className='icon'>
          <i className='bx bx-bell-minus' />
          <div className='label'>bx-bell-minus</div>
        </div>
        <div className='icon'>
          <i className='bx bx-bell-off' />
          <div className='label'>bx-bell-off</div>
        </div>
        <div className='icon'>
          <i className='bx bx-bell-plus' />
          <div className='label'>bx-bell-plus</div>
        </div>
        <div className='icon'>
          <i className='bx bx-bible' />
          <div className='label'>bx-bible</div>
        </div>
        <div className='icon'>
          <i className='bx bx-bitcoin' />
          <div className='label'>bx-bitcoin</div>
        </div>
        <div className='icon'>
          <i className='bx bx-blanket' />
          <div className='label'>bx-blanket</div>
        </div>
        <div className='icon'>
          <i className='bx bx-block' />
          <div className='label'>bx-block</div>
        </div>
        <div className='icon'>
          <i className='bx bx-bluetooth' />
          <div className='label'>bx-bluetooth</div>
        </div>
        <div className='icon'>
          <i className='bx bx-body' />
          <div className='label'>bx-body</div>
        </div>
        <div className='icon'>
          <i className='bx bx-bold' />
          <div className='label'>bx-bold</div>
        </div>
        <div className='icon'>
          <i className='bx bx-bolt-circle' />
          <div className='label'>bx-bolt-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bx-bomb' />
          <div className='label'>bx-bomb</div>
        </div>
        <div className='icon'>
          <i className='bx bx-bone' />
          <div className='label'>bx-bone</div>
        </div>
        <div className='icon'>
          <i className='bx bx-bong' />
          <div className='label'>bx-bong</div>
        </div>
        <div className='icon'>
          <i className='bx bx-book' />
          <div className='label'>bx-book</div>
        </div>
        <div className='icon'>
          <i className='bx bx-book-add' />
          <div className='label'>bx-book-add</div>
        </div>
        <div className='icon'>
          <i className='bx bx-book-alt' />
          <div className='label'>bx-book-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bx-book-bookmark' />
          <div className='label'>bx-book-bookmark</div>
        </div>
        <div className='icon'>
          <i className='bx bx-book-content' />
          <div className='label'>bx-book-content</div>
        </div>
        <div className='icon'>
          <i className='bx bx-book-heart' />
          <div className='label'>bx-book-heart</div>
        </div>
        <div className='icon'>
          <i className='bx bx-bookmark' />
          <div className='label'>bx-bookmark</div>
        </div>
        <div className='icon'>
          <i className='bx bx-bookmark-alt' />
          <div className='label'>bx-bookmark-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bx-bookmark-alt-minus' />
          <div className='label'>bx-bookmark-alt-minus</div>
        </div>
        <div className='icon'>
          <i className='bx bx-bookmark-alt-plus' />
          <div className='label'>bx-bookmark-alt-plus</div>
        </div>
        <div className='icon'>
          <i className='bx bx-bookmark-heart' />
          <div className='label'>bx-bookmark-heart</div>
        </div>
        <div className='icon'>
          <i className='bx bx-bookmark-minus' />
          <div className='label'>bx-bookmark-minus</div>
        </div>
        <div className='icon'>
          <i className='bx bx-bookmark-plus' />
          <div className='label'>bx-bookmark-plus</div>
        </div>
        <div className='icon'>
          <i className='bx bx-bookmarks' />
          <div className='label'>bx-bookmarks</div>
        </div>
        <div className='icon'>
          <i className='bx bx-book-open' />
          <div className='label'>bx-book-open</div>
        </div>
        <div className='icon'>
          <i className='bx bx-book-reader' />
          <div className='label'>bx-book-reader</div>
        </div>
        <div className='icon'>
          <i className='bx bx-border-all' />
          <div className='label'>bx-border-all</div>
        </div>
        <div className='icon'>
          <i className='bx bx-border-bottom' />
          <div className='label'>bx-border-bottom</div>
        </div>
        <div className='icon'>
          <i className='bx bx-border-inner' />
          <div className='label'>bx-border-inner</div>
        </div>
        <div className='icon'>
          <i className='bx bx-border-left' />
          <div className='label'>bx-border-left</div>
        </div>
        <div className='icon'>
          <i className='bx bx-border-none' />
          <div className='label'>bx-border-none</div>
        </div>
        <div className='icon'>
          <i className='bx bx-border-outer' />
          <div className='label'>bx-border-outer</div>
        </div>
        <div className='icon'>
          <i className='bx bx-border-radius' />
          <div className='label'>bx-border-radius</div>
        </div>
        <div className='icon'>
          <i className='bx bx-border-right' />
          <div className='label'>bx-border-right</div>
        </div>
        <div className='icon'>
          <i className='bx bx-border-top' />
          <div className='label'>bx-border-top</div>
        </div>
        <div className='icon'>
          <i className='bx bx-bot' />
          <div className='label'>bx-bot</div>
        </div>
        <div className='icon'>
          <i className='bx bx-bowling-ball' />
          <div className='label'>bx-bowling-ball</div>
        </div>
        <div className='icon'>
          <i className='bx bx-box' />
          <div className='label'>bx-box</div>
        </div>
        <div className='icon'>
          <i className='bx bx-bracket' />
          <div className='label'>bx-bracket</div>
        </div>
        <div className='icon'>
          <i className='bx bx-braille' />
          <div className='label'>bx-braille</div>
        </div>
        <div className='icon'>
          <i className='bx bx-brain' />
          <div className='label'>bx-brain</div>
        </div>
        <div className='icon'>
          <i className='bx bx-briefcase' />
          <div className='label'>bx-briefcase</div>
        </div>
        <div className='icon'>
          <i className='bx bx-briefcase-alt' />
          <div className='label'>bx-briefcase-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bx-briefcase-alt-2' />
          <div className='label'>bx-briefcase-alt-2</div>
        </div>
        <div className='icon'>
          <i className='bx bx-brightness' />
          <div className='label'>bx-brightness</div>
        </div>
        <div className='icon'>
          <i className='bx bx-brightness-half' />
          <div className='label'>bx-brightness-half</div>
        </div>
        <div className='icon'>
          <i className='bx bx-broadcast' />
          <div className='label'>bx-broadcast</div>
        </div>
        <div className='icon'>
          <i className='bx bx-brush' />
          <div className='label'>bx-brush</div>
        </div>
        <div className='icon'>
          <i className='bx bx-brush-alt' />
          <div className='label'>bx-brush-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bx-bug' />
          <div className='label'>bx-bug</div>
        </div>
        <div className='icon'>
          <i className='bx bx-bug-alt' />
          <div className='label'>bx-bug-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bx-building' />
          <div className='label'>bx-building</div>
        </div>
        <div className='icon'>
          <i className='bx bx-building-house' />
          <div className='label'>bx-building-house</div>
        </div>
        <div className='icon'>
          <i className='bx bx-buildings' />
          <div className='label'>bx-buildings</div>
        </div>
        <div className='icon'>
          <i className='bx bx-bulb' />
          <div className='label'>bx-bulb</div>
        </div>
        <div className='icon'>
          <i className='bx bx-bullseye' />
          <div className='label'>bx-bullseye</div>
        </div>
        <div className='icon'>
          <i className='bx bx-buoy' />
          <div className='label'>bx-buoy</div>
        </div>
        <div className='icon'>
          <i className='bx bx-bus' />
          <div className='label'>bx-bus</div>
        </div>
        <div className='icon'>
          <i className='bx bx-bus-school' />
          <div className='label'>bx-bus-school</div>
        </div>
        <div className='icon'>
          <i className='bx bx-cabinet' />
          <div className='label'>bx-cabinet</div>
        </div>
        <div className='icon'>
          <i className='bx bx-cake' />
          <div className='label'>bx-cake</div>
        </div>
        <div className='icon'>
          <i className='bx bx-calculator' />
          <div className='label'>bx-calculator</div>
        </div>
        <div className='icon'>
          <i className='bx bx-calendar' />
          <div className='label'>bx-calendar</div>
        </div>
        <div className='icon'>
          <i className='bx bx-calendar-alt' />
          <div className='label'>bx-calendar-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bx-calendar-check' />
          <div className='label'>bx-calendar-check</div>
        </div>
        <div className='icon'>
          <i className='bx bx-calendar-edit' />
          <div className='label'>bx-calendar-edit</div>
        </div>
        <div className='icon'>
          <i className='bx bx-calendar-event' />
          <div className='label'>bx-calendar-event</div>
        </div>
        <div className='icon'>
          <i className='bx bx-calendar-exclamation' />
          <div className='label'>bx-calendar-exclamation</div>
        </div>
        <div className='icon'>
          <i className='bx bx-calendar-heart' />
          <div className='label'>bx-calendar-heart</div>
        </div>
        <div className='icon'>
          <i className='bx bx-calendar-minus' />
          <div className='label'>bx-calendar-minus</div>
        </div>
        <div className='icon'>
          <i className='bx bx-calendar-plus' />
          <div className='label'>bx-calendar-plus</div>
        </div>
        <div className='icon'>
          <i className='bx bx-calendar-star' />
          <div className='label'>bx-calendar-star</div>
        </div>
        <div className='icon'>
          <i className='bx bx-calendar-week' />
          <div className='label'>bx-calendar-week</div>
        </div>
        <div className='icon'>
          <i className='bx bx-calendar-x' />
          <div className='label'>bx-calendar-x</div>
        </div>
        <div className='icon'>
          <i className='bx bx-camera' />
          <div className='label'>bx-camera</div>
        </div>
        <div className='icon'>
          <i className='bx bx-camera-home' />
          <div className='label'>bx-camera-home</div>
        </div>
        <div className='icon'>
          <i className='bx bx-camera-movie' />
          <div className='label'>bx-camera-movie</div>
        </div>
        <div className='icon'>
          <i className='bx bx-camera-off' />
          <div className='label'>bx-camera-off</div>
        </div>
        <div className='icon'>
          <i className='bx bx-capsule' />
          <div className='label'>bx-capsule</div>
        </div>
        <div className='icon'>
          <i className='bx bx-captions' />
          <div className='label'>bx-captions</div>
        </div>
        <div className='icon'>
          <i className='bx bx-car' />
          <div className='label'>bx-car</div>
        </div>
        <div className='icon'>
          <i className='bx bx-card' />
          <div className='label'>bx-card</div>
        </div>
        <div className='icon'>
          <i className='bx bx-caret-down' />
          <div className='label'>bx-caret-down</div>
        </div>
        <div className='icon'>
          <i className='bx bx-caret-down-circle' />
          <div className='label'>bx-caret-down-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bx-caret-down-square' />
          <div className='label'>bx-caret-down-square</div>
        </div>
        <div className='icon'>
          <i className='bx bx-caret-left' />
          <div className='label'>bx-caret-left</div>
        </div>
        <div className='icon'>
          <i className='bx bx-caret-left-circle' />
          <div className='label'>bx-caret-left-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bx-caret-left-square' />
          <div className='label'>bx-caret-left-square</div>
        </div>
        <div className='icon'>
          <i className='bx bx-caret-right' />
          <div className='label'>bx-caret-right</div>
        </div>
        <div className='icon'>
          <i className='bx bx-caret-right-circle' />
          <div className='label'>bx-caret-right-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bx-caret-right-square' />
          <div className='label'>bx-caret-right-square</div>
        </div>
        <div className='icon'>
          <i className='bx bx-caret-up' />
          <div className='label'>bx-caret-up</div>
        </div>
        <div className='icon'>
          <i className='bx bx-caret-up-circle' />
          <div className='label'>bx-caret-up-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bx-caret-up-square' />
          <div className='label'>bx-caret-up-square</div>
        </div>
        <div className='icon'>
          <i className='bx bx-carousel' />
          <div className='label'>bx-carousel</div>
        </div>
        <div className='icon'>
          <i className='bx bx-cart' />
          <div className='label'>bx-cart</div>
        </div>
        <div className='icon'>
          <i className='bx bx-cart-alt' />
          <div className='label'>bx-cart-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bx-cast' />
          <div className='label'>bx-cast</div>
        </div>
        <div className='icon'>
          <i className='bx bx-category' />
          <div className='label'>bx-category</div>
        </div>
        <div className='icon'>
          <i className='bx bx-category-alt' />
          <div className='label'>bx-category-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bx-cctv' />
          <div className='label'>bx-cctv</div>
        </div>
        <div className='icon'>
          <i className='bx bx-certification' />
          <div className='label'>bx-certification</div>
        </div>
        <div className='icon'>
          <i className='bx bx-chair' />
          <div className='label'>bx-chair</div>
        </div>
        <div className='icon'>
          <i className='bx bx-chalkboard' />
          <div className='label'>bx-chalkboard</div>
        </div>
        <div className='icon'>
          <i className='bx bx-chart' />
          <div className='label'>bx-chart</div>
        </div>
        <div className='icon'>
          <i className='bx bx-chat' />
          <div className='label'>bx-chat</div>
        </div>
        <div className='icon'>
          <i className='bx bx-check' />
          <div className='label'>bx-check</div>
        </div>
        <div className='icon'>
          <i className='bx bx-checkbox' />
          <div className='label'>bx-checkbox</div>
        </div>
        <div className='icon'>
          <i className='bx bx-checkbox-checked' />
          <div className='label'>bx-checkbox-checked</div>
        </div>
        <div className='icon'>
          <i className='bx bx-checkbox-minus' />
          <div className='label'>bx-checkbox-minus</div>
        </div>
        <div className='icon'>
          <i className='bx bx-checkbox-square' />
          <div className='label'>bx-checkbox-square</div>
        </div>
        <div className='icon'>
          <i className='bx bx-check-circle' />
          <div className='label'>bx-check-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bx-check-double' />
          <div className='label'>bx-check-double</div>
        </div>
        <div className='icon'>
          <i className='bx bx-check-shield' />
          <div className='label'>bx-check-shield</div>
        </div>
        <div className='icon'>
          <i className='bx bx-check-square' />
          <div className='label'>bx-check-square</div>
        </div>
        <div className='icon'>
          <i className='bx bx-chevron-down' />
          <div className='label'>bx-chevron-down</div>
        </div>
        <div className='icon'>
          <i className='bx bx-chevron-down-circle' />
          <div className='label'>bx-chevron-down-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bx-chevron-down-square' />
          <div className='label'>bx-chevron-down-square</div>
        </div>
        <div className='icon'>
          <i className='bx bx-chevron-left' />
          <div className='label'>bx-chevron-left</div>
        </div>
        <div className='icon'>
          <i className='bx bx-chevron-left-circle' />
          <div className='label'>bx-chevron-left-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bx-chevron-left-square' />
          <div className='label'>bx-chevron-left-square</div>
        </div>
        <div className='icon'>
          <i className='bx bx-chevron-right' />
          <div className='label'>bx-chevron-right</div>
        </div>
        <div className='icon'>
          <i className='bx bx-chevron-right-circle' />
          <div className='label'>bx-chevron-right-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bx-chevron-right-square' />
          <div className='label'>bx-chevron-right-square</div>
        </div>
        <div className='icon'>
          <i className='bx bx-chevrons-down' />
          <div className='label'>bx-chevrons-down</div>
        </div>
        <div className='icon'>
          <i className='bx bx-chevrons-left' />
          <div className='label'>bx-chevrons-left</div>
        </div>
        <div className='icon'>
          <i className='bx bx-chevrons-right' />
          <div className='label'>bx-chevrons-right</div>
        </div>
        <div className='icon'>
          <i className='bx bx-chevrons-up' />
          <div className='label'>bx-chevrons-up</div>
        </div>
        <div className='icon'>
          <i className='bx bx-chevron-up' />
          <div className='label'>bx-chevron-up</div>
        </div>
        <div className='icon'>
          <i className='bx bx-chevron-up-circle' />
          <div className='label'>bx-chevron-up-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bx-chevron-up-square' />
          <div className='label'>bx-chevron-up-square</div>
        </div>
        <div className='icon'>
          <i className='bx bx-chip' />
          <div className='label'>bx-chip</div>
        </div>
        <div className='icon'>
          <i className='bx bx-church' />
          <div className='label'>bx-church</div>
        </div>
        <div className='icon'>
          <i className='bx bx-circle' />
          <div className='label'>bx-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bx-clinic' />
          <div className='label'>bx-clinic</div>
        </div>
        <div className='icon'>
          <i className='bx bx-clipboard' />
          <div className='label'>bx-clipboard</div>
        </div>
        <div className='icon'>
          <i className='bx bx-closet' />
          <div className='label'>bx-closet</div>
        </div>
        <div className='icon'>
          <i className='bx bx-cloud' />
          <div className='label'>bx-cloud</div>
        </div>
        <div className='icon'>
          <i className='bx bx-cloud-download' />
          <div className='label'>bx-cloud-download</div>
        </div>
        <div className='icon'>
          <i className='bx bx-cloud-drizzle' />
          <div className='label'>bx-cloud-drizzle</div>
        </div>
        <div className='icon'>
          <i className='bx bx-cloud-lightning' />
          <div className='label'>bx-cloud-lightning</div>
        </div>
        <div className='icon'>
          <i className='bx bx-cloud-light-rain' />
          <div className='label'>bx-cloud-light-rain</div>
        </div>
        <div className='icon'>
          <i className='bx bx-cloud-rain' />
          <div className='label'>bx-cloud-rain</div>
        </div>
        <div className='icon'>
          <i className='bx bx-cloud-snow' />
          <div className='label'>bx-cloud-snow</div>
        </div>
        <div className='icon'>
          <i className='bx bx-cloud-upload' />
          <div className='label'>bx-cloud-upload</div>
        </div>
        <div className='icon'>
          <i className='bx bx-code' />
          <div className='label'>bx-code</div>
        </div>
        <div className='icon'>
          <i className='bx bx-code-alt' />
          <div className='label'>bx-code-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bx-code-block' />
          <div className='label'>bx-code-block</div>
        </div>
        <div className='icon'>
          <i className='bx bx-code-curly' />
          <div className='label'>bx-code-curly</div>
        </div>
        <div className='icon'>
          <i className='bx bx-coffee' />
          <div className='label'>bx-coffee</div>
        </div>
        <div className='icon'>
          <i className='bx bx-coffee-togo' />
          <div className='label'>bx-coffee-togo</div>
        </div>
        <div className='icon'>
          <i className='bx bx-cog' />
          <div className='label'>bx-cog</div>
        </div>
        <div className='icon'>
          <i className='bx bx-coin' />
          <div className='label'>bx-coin</div>
        </div>
        <div className='icon'>
          <i className='bx bx-coin-stack' />
          <div className='label'>bx-coin-stack</div>
        </div>
        <div className='icon'>
          <i className='bx bx-collapse' />
          <div className='label'>bx-collapse</div>
        </div>
        <div className='icon'>
          <i className='bx bx-collection' />
          <div className='label'>bx-collection</div>
        </div>
        <div className='icon'>
          <i className='bx bx-color-fill' />
          <div className='label'>bx-color-fill</div>
        </div>
        <div className='icon'>
          <i className='bx bx-columns' />
          <div className='label'>bx-columns</div>
        </div>
        <div className='icon'>
          <i className='bx bx-command' />
          <div className='label'>bx-command</div>
        </div>
        <div className='icon'>
          <i className='bx bx-comment' />
          <div className='label'>bx-comment</div>
        </div>
        <div className='icon'>
          <i className='bx bx-comment-add' />
          <div className='label'>bx-comment-add</div>
        </div>
        <div className='icon'>
          <i className='bx bx-comment-check' />
          <div className='label'>bx-comment-check</div>
        </div>
        <div className='icon'>
          <i className='bx bx-comment-detail' />
          <div className='label'>bx-comment-detail</div>
        </div>
        <div className='icon'>
          <i className='bx bx-comment-dots' />
          <div className='label'>bx-comment-dots</div>
        </div>
        <div className='icon'>
          <i className='bx bx-comment-edit' />
          <div className='label'>bx-comment-edit</div>
        </div>
        <div className='icon'>
          <i className='bx bx-comment-error' />
          <div className='label'>bx-comment-error</div>
        </div>
        <div className='icon'>
          <i className='bx bx-comment-minus' />
          <div className='label'>bx-comment-minus</div>
        </div>
        <div className='icon'>
          <i className='bx bx-comment-x' />
          <div className='label'>bx-comment-x</div>
        </div>
        <div className='icon'>
          <i className='bx bx-compass' />
          <div className='label'>bx-compass</div>
        </div>
        <div className='icon'>
          <i className='bx bx-confused' />
          <div className='label'>bx-confused</div>
        </div>
        <div className='icon'>
          <i className='bx bx-conversation' />
          <div className='label'>bx-conversation</div>
        </div>
        <div className='icon'>
          <i className='bx bx-cookie' />
          <div className='label'>bx-cookie</div>
        </div>
        <div className='icon'>
          <i className='bx bx-cool' />
          <div className='label'>bx-cool</div>
        </div>
        <div className='icon'>
          <i className='bx bx-copy' />
          <div className='label'>bx-copy</div>
        </div>
        <div className='icon'>
          <i className='bx bx-copy-alt' />
          <div className='label'>bx-copy-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bx-copyright' />
          <div className='label'>bx-copyright</div>
        </div>
        <div className='icon'>
          <i className='bx bx-credit-card' />
          <div className='label'>bx-credit-card</div>
        </div>
        <div className='icon'>
          <i className='bx bx-credit-card-alt' />
          <div className='label'>bx-credit-card-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bx-credit-card-front' />
          <div className='label'>bx-credit-card-front</div>
        </div>
        <div className='icon'>
          <i className='bx bx-crop' />
          <div className='label'>bx-crop</div>
        </div>
        <div className='icon'>
          <i className='bx bx-crosshair' />
          <div className='label'>bx-crosshair</div>
        </div>
        <div className='icon'>
          <i className='bx bx-crown' />
          <div className='label'>bx-crown</div>
        </div>
        <div className='icon'>
          <i className='bx bx-cube' />
          <div className='label'>bx-cube</div>
        </div>
        <div className='icon'>
          <i className='bx bx-cube-alt' />
          <div className='label'>bx-cube-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bx-cuboid' />
          <div className='label'>bx-cuboid</div>
        </div>
        <div className='icon'>
          <i className='bx bx-current-location' />
          <div className='label'>bx-current-location</div>
        </div>
        <div className='icon'>
          <i className='bx bx-customize' />
          <div className='label'>bx-customize</div>
        </div>
        <div className='icon'>
          <i className='bx bx-cut' />
          <div className='label'>bx-cut</div>
        </div>
        <div className='icon'>
          <i className='bx bx-cycling' />
          <div className='label'>bx-cycling</div>
        </div>
        <div className='icon'>
          <i className='bx bx-cylinder' />
          <div className='label'>bx-cylinder</div>
        </div>
        <div className='icon'>
          <i className='bx bx-data' />
          <div className='label'>bx-data</div>
        </div>
        <div className='icon'>
          <i className='bx bx-desktop' />
          <div className='label'>bx-desktop</div>
        </div>
        <div className='icon'>
          <i className='bx bx-detail' />
          <div className='label'>bx-detail</div>
        </div>
        <div className='icon'>
          <i className='bx bx-devices' />
          <div className='label'>bx-devices</div>
        </div>
        <div className='icon'>
          <i className='bx bx-dialpad' />
          <div className='label'>bx-dialpad</div>
        </div>
        <div className='icon'>
          <i className='bx bx-dialpad-alt' />
          <div className='label'>bx-dialpad-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bx-diamond' />
          <div className='label'>bx-diamond</div>
        </div>
        <div className='icon'>
          <i className='bx bx-dice-1' />
          <div className='label'>bx-dice-1</div>
        </div>
        <div className='icon'>
          <i className='bx bx-dice-2' />
          <div className='label'>bx-dice-2</div>
        </div>
        <div className='icon'>
          <i className='bx bx-dice-3' />
          <div className='label'>bx-dice-3</div>
        </div>
        <div className='icon'>
          <i className='bx bx-dice-4' />
          <div className='label'>bx-dice-4</div>
        </div>
        <div className='icon'>
          <i className='bx bx-dice-5' />
          <div className='label'>bx-dice-5</div>
        </div>
        <div className='icon'>
          <i className='bx bx-dice-6' />
          <div className='label'>bx-dice-6</div>
        </div>
        <div className='icon'>
          <i className='bx bx-directions' />
          <div className='label'>bx-directions</div>
        </div>
        <div className='icon'>
          <i className='bx bx-disc' />
          <div className='label'>bx-disc</div>
        </div>
        <div className='icon'>
          <i className='bx bx-dish' />
          <div className='label'>bx-dish</div>
        </div>
        <div className='icon'>
          <i className='bx bx-dislike' />
          <div className='label'>bx-dislike</div>
        </div>
        <div className='icon'>
          <i className='bx bx-dizzy' />
          <div className='label'>bx-dizzy</div>
        </div>
        <div className='icon'>
          <i className='bx bx-dna' />
          <div className='label'>bx-dna</div>
        </div>
        <div className='icon'>
          <i className='bx bx-dock-bottom' />
          <div className='label'>bx-dock-bottom</div>
        </div>
        <div className='icon'>
          <i className='bx bx-dock-left' />
          <div className='label'>bx-dock-left</div>
        </div>
        <div className='icon'>
          <i className='bx bx-dock-right' />
          <div className='label'>bx-dock-right</div>
        </div>
        <div className='icon'>
          <i className='bx bx-dock-top' />
          <div className='label'>bx-dock-top</div>
        </div>
        <div className='icon'>
          <i className='bx bx-dollar' />
          <div className='label'>bx-dollar</div>
        </div>
        <div className='icon'>
          <i className='bx bx-dollar-circle' />
          <div className='label'>bx-dollar-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bx-donate-blood' />
          <div className='label'>bx-donate-blood</div>
        </div>
        <div className='icon'>
          <i className='bx bx-donate-heart' />
          <div className='label'>bx-donate-heart</div>
        </div>
        <div className='icon'>
          <i className='bx bx-door-open' />
          <div className='label'>bx-door-open</div>
        </div>
        <div className='icon'>
          <i className='bx bx-dots-horizontal' />
          <div className='label'>bx-dots-horizontal</div>
        </div>
        <div className='icon'>
          <i className='bx bx-dots-horizontal-rounded' />
          <div className='label'>bx-dots-horizontal-rounded</div>
        </div>
        <div className='icon'>
          <i className='bx bx-dots-vertical' />
          <div className='label'>bx-dots-vertical</div>
        </div>
        <div className='icon'>
          <i className='bx bx-dots-vertical-rounded' />
          <div className='label'>bx-dots-vertical-rounded</div>
        </div>
        <div className='icon'>
          <i className='bx bx-doughnut-chart' />
          <div className='label'>bx-doughnut-chart</div>
        </div>
        <div className='icon'>
          <i className='bx bx-down-arrow' />
          <div className='label'>bx-down-arrow</div>
        </div>
        <div className='icon'>
          <i className='bx bx-down-arrow-alt' />
          <div className='label'>bx-down-arrow-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bx-down-arrow-circle' />
          <div className='label'>bx-down-arrow-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bx-download' />
          <div className='label'>bx-download</div>
        </div>
        <div className='icon'>
          <i className='bx bx-downvote' />
          <div className='label'>bx-downvote</div>
        </div>
        <div className='icon'>
          <i className='bx bx-drink' />
          <div className='label'>bx-drink</div>
        </div>
        <div className='icon'>
          <i className='bx bx-droplet' />
          <div className='label'>bx-droplet</div>
        </div>
        <div className='icon'>
          <i className='bx bx-dumbbell' />
          <div className='label'>bx-dumbbell</div>
        </div>
        <div className='icon'>
          <i className='bx bx-duplicate' />
          <div className='label'>bx-duplicate</div>
        </div>
        <div className='icon'>
          <i className='bx bx-edit' />
          <div className='label'>bx-edit</div>
        </div>
        <div className='icon'>
          <i className='bx bx-edit-alt' />
          <div className='label'>bx-edit-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bx-envelope' />
          <div className='label'>bx-envelope</div>
        </div>
        <div className='icon'>
          <i className='bx bx-envelope-open' />
          <div className='label'>bx-envelope-open</div>
        </div>
        <div className='icon'>
          <i className='bx bx-equalizer' />
          <div className='label'>bx-equalizer</div>
        </div>
        <div className='icon'>
          <i className='bx bx-eraser' />
          <div className='label'>bx-eraser</div>
        </div>
        <div className='icon'>
          <i className='bx bx-error' />
          <div className='label'>bx-error</div>
        </div>
        <div className='icon'>
          <i className='bx bx-error-alt' />
          <div className='label'>bx-error-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bx-error-circle' />
          <div className='label'>bx-error-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bx-euro' />
          <div className='label'>bx-euro</div>
        </div>
        <div className='icon'>
          <i className='bx bx-exclude' />
          <div className='label'>bx-exclude</div>
        </div>
        <div className='icon'>
          <i className='bx bx-exit' />
          <div className='label'>bx-exit</div>
        </div>
        <div className='icon'>
          <i className='bx bx-exit-fullscreen' />
          <div className='label'>bx-exit-fullscreen</div>
        </div>
        <div className='icon'>
          <i className='bx bx-expand' />
          <div className='label'>bx-expand</div>
        </div>
        <div className='icon'>
          <i className='bx bx-expand-alt' />
          <div className='label'>bx-expand-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bx-export' />
          <div className='label'>bx-export</div>
        </div>
        <div className='icon'>
          <i className='bx bx-extension' />
          <div className='label'>bx-extension</div>
        </div>
        <div className='icon'>
          <i className='bx bx-face' />
          <div className='label'>bx-face</div>
        </div>
        <div className='icon'>
          <i className='bx bx-fast-forward' />
          <div className='label'>bx-fast-forward</div>
        </div>
        <div className='icon'>
          <i className='bx bx-fast-forward-circle' />
          <div className='label'>bx-fast-forward-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bx-female' />
          <div className='label'>bx-female</div>
        </div>
        <div className='icon'>
          <i className='bx bx-female-sign' />
          <div className='label'>bx-female-sign</div>
        </div>
        <div className='icon'>
          <i className='bx bx-file' />
          <div className='label'>bx-file</div>
        </div>
        <div className='icon'>
          <i className='bx bx-file-blank' />
          <div className='label'>bx-file-blank</div>
        </div>
        <div className='icon'>
          <i className='bx bx-file-find' />
          <div className='label'>bx-file-find</div>
        </div>
        <div className='icon'>
          <i className='bx bx-film' />
          <div className='label'>bx-film</div>
        </div>
        <div className='icon'>
          <i className='bx bx-filter' />
          <div className='label'>bx-filter</div>
        </div>
        <div className='icon'>
          <i className='bx bx-filter-alt' />
          <div className='label'>bx-filter-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bx-fingerprint' />
          <div className='label'>bx-fingerprint</div>
        </div>
        <div className='icon'>
          <i className='bx bx-first-aid' />
          <div className='label'>bx-first-aid</div>
        </div>
        <div className='icon'>
          <i className='bx bx-first-page' />
          <div className='label'>bx-first-page</div>
        </div>
        <div className='icon'>
          <i className='bx bx-flag' />
          <div className='label'>bx-flag</div>
        </div>
        <div className='icon'>
          <i className='bx bx-folder' />
          <div className='label'>bx-folder</div>
        </div>
        <div className='icon'>
          <i className='bx bx-folder-minus' />
          <div className='label'>bx-folder-minus</div>
        </div>
        <div className='icon'>
          <i className='bx bx-folder-open' />
          <div className='label'>bx-folder-open</div>
        </div>
        <div className='icon'>
          <i className='bx bx-folder-plus' />
          <div className='label'>bx-folder-plus</div>
        </div>
        <div className='icon'>
          <i className='bx bx-font' />
          <div className='label'>bx-font</div>
        </div>
        <div className='icon'>
          <i className='bx bx-font-color' />
          <div className='label'>bx-font-color</div>
        </div>
        <div className='icon'>
          <i className='bx bx-font-family' />
          <div className='label'>bx-font-family</div>
        </div>
        <div className='icon'>
          <i className='bx bx-font-size' />
          <div className='label'>bx-font-size</div>
        </div>
        <div className='icon'>
          <i className='bx bx-food-menu' />
          <div className='label'>bx-food-menu</div>
        </div>
        <div className='icon'>
          <i className='bx bx-food-tag' />
          <div className='label'>bx-food-tag</div>
        </div>
        <div className='icon'>
          <i className='bx bx-football' />
          <div className='label'>bx-football</div>
        </div>
        <div className='icon'>
          <i className='bx bx-fridge' />
          <div className='label'>bx-fridge</div>
        </div>
        <div className='icon'>
          <i className='bx bx-fullscreen' />
          <div className='label'>bx-fullscreen</div>
        </div>
        <div className='icon'>
          <i className='bx bx-game' />
          <div className='label'>bx-game</div>
        </div>
        <div className='icon'>
          <i className='bx bx-gas-pump' />
          <div className='label'>bx-gas-pump</div>
        </div>
        <div className='icon'>
          <i className='bx bx-ghost' />
          <div className='label'>bx-ghost</div>
        </div>
        <div className='icon'>
          <i className='bx bx-gift' />
          <div className='label'>bx-gift</div>
        </div>
        <div className='icon'>
          <i className='bx bx-git-branch' />
          <div className='label'>bx-git-branch</div>
        </div>
        <div className='icon'>
          <i className='bx bx-git-commit' />
          <div className='label'>bx-git-commit</div>
        </div>
        <div className='icon'>
          <i className='bx bx-git-compare' />
          <div className='label'>bx-git-compare</div>
        </div>
        <div className='icon'>
          <i className='bx bx-git-merge' />
          <div className='label'>bx-git-merge</div>
        </div>
        <div className='icon'>
          <i className='bx bx-git-pull-request' />
          <div className='label'>bx-git-pull-request</div>
        </div>
        <div className='icon'>
          <i className='bx bx-git-repo-forked' />
          <div className='label'>bx-git-repo-forked</div>
        </div>
        <div className='icon'>
          <i className='bx bx-glasses' />
          <div className='label'>bx-glasses</div>
        </div>
        <div className='icon'>
          <i className='bx bx-glasses-alt' />
          <div className='label'>bx-glasses-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bx-globe' />
          <div className='label'>bx-globe</div>
        </div>
        <div className='icon'>
          <i className='bx bx-globe-alt' />
          <div className='label'>bx-globe-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bx-grid' />
          <div className='label'>bx-grid</div>
        </div>
        <div className='icon'>
          <i className='bx bx-grid-alt' />
          <div className='label'>bx-grid-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bx-grid-horizontal' />
          <div className='label'>bx-grid-horizontal</div>
        </div>
        <div className='icon'>
          <i className='bx bx-grid-small' />
          <div className='label'>bx-grid-small</div>
        </div>
        <div className='icon'>
          <i className='bx bx-grid-vertical' />
          <div className='label'>bx-grid-vertical</div>
        </div>
        <div className='icon'>
          <i className='bx bx-group' />
          <div className='label'>bx-group</div>
        </div>
        <div className='icon'>
          <i className='bx bx-handicap' />
          <div className='label'>bx-handicap</div>
        </div>
        <div className='icon'>
          <i className='bx bx-happy' />
          <div className='label'>bx-happy</div>
        </div>
        <div className='icon'>
          <i className='bx bx-happy-alt' />
          <div className='label'>bx-happy-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bx-happy-beaming' />
          <div className='label'>bx-happy-beaming</div>
        </div>
        <div className='icon'>
          <i className='bx bx-happy-heart-eyes' />
          <div className='label'>bx-happy-heart-eyes</div>
        </div>
        <div className='icon'>
          <i className='bx bx-hash' />
          <div className='label'>bx-hash</div>
        </div>
        <div className='icon'>
          <i className='bx bx-hdd' />
          <div className='label'>bx-hdd</div>
        </div>
        <div className='icon'>
          <i className='bx bx-heading' />
          <div className='label'>bx-heading</div>
        </div>
        <div className='icon'>
          <i className='bx bx-headphone' />
          <div className='label'>bx-headphone</div>
        </div>
        <div className='icon'>
          <i className='bx bx-health' />
          <div className='label'>bx-health</div>
        </div>
        <div className='icon'>
          <i className='bx bx-heart' />
          <div className='label'>bx-heart</div>
        </div>
        <div className='icon'>
          <i className='bx bx-heart-circle' />
          <div className='label'>bx-heart-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bx-heart-square' />
          <div className='label'>bx-heart-square</div>
        </div>
        <div className='icon'>
          <i className='bx bx-help-circle' />
          <div className='label'>bx-help-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bx-hide' />
          <div className='label'>bx-hide</div>
        </div>
        <div className='icon'>
          <i className='bx bx-highlight' />
          <div className='label'>bx-highlight</div>
        </div>
        <div className='icon'>
          <i className='bx bx-history' />
          <div className='label'>bx-history</div>
        </div>
        <div className='icon'>
          <i className='bx bx-hive' />
          <div className='label'>bx-hive</div>
        </div>
        <div className='icon'>
          <i className='bx bx-home' />
          <div className='label'>bx-home</div>
        </div>
        <div className='icon'>
          <i className='bx bx-home-alt' />
          <div className='label'>bx-home-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bx-home-circle' />
          <div className='label'>bx-home-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bx-home-heart' />
          <div className='label'>bx-home-heart</div>
        </div>
        <div className='icon'>
          <i className='bx bx-home-smile' />
          <div className='label'>bx-home-smile</div>
        </div>
        <div className='icon'>
          <i className='bx bx-horizontal-center' />
          <div className='label'>bx-horizontal-center</div>
        </div>
        <div className='icon'>
          <i className='bx bx-hotel' />
          <div className='label'>bx-hotel</div>
        </div>
        <div className='icon'>
          <i className='bx bx-hourglass' />
          <div className='label'>bx-hourglass</div>
        </div>
        <div className='icon'>
          <i className='bx bx-id-card' />
          <div className='label'>bx-id-card</div>
        </div>
        <div className='icon'>
          <i className='bx bx-image' />
          <div className='label'>bx-image</div>
        </div>
        <div className='icon'>
          <i className='bx bx-image-add' />
          <div className='label'>bx-image-add</div>
        </div>
        <div className='icon'>
          <i className='bx bx-image-alt' />
          <div className='label'>bx-image-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bx-images' />
          <div className='label'>bx-images</div>
        </div>
        <div className='icon'>
          <i className='bx bx-import' />
          <div className='label'>bx-import</div>
        </div>
        <div className='icon'>
          <i className='bx bx-infinite' />
          <div className='label'>bx-infinite</div>
        </div>
        <div className='icon'>
          <i className='bx bx-info-circle' />
          <div className='label'>bx-info-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bx-info-square' />
          <div className='label'>bx-info-square</div>
        </div>
        <div className='icon'>
          <i className='bx bx-intersect' />
          <div className='label'>bx-intersect</div>
        </div>
        <div className='icon'>
          <i className='bx bx-italic' />
          <div className='label'>bx-italic</div>
        </div>
        <div className='icon'>
          <i className='bx bx-joystick' />
          <div className='label'>bx-joystick</div>
        </div>
        <div className='icon'>
          <i className='bx bx-joystick-alt' />
          <div className='label'>bx-joystick-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bx-joystick-button' />
          <div className='label'>bx-joystick-button</div>
        </div>
        <div className='icon'>
          <i className='bx bx-key' />
          <div className='label'>bx-key</div>
        </div>
        <div className='icon'>
          <i className='bx bx-label' />
          <div className='label'>bx-label</div>
        </div>
        <div className='icon'>
          <i className='bx bx-landscape' />
          <div className='label'>bx-landscape</div>
        </div>
        <div className='icon'>
          <i className='bx bx-laptop' />
          <div className='label'>bx-laptop</div>
        </div>
        <div className='icon'>
          <i className='bx bx-last-page' />
          <div className='label'>bx-last-page</div>
        </div>
        <div className='icon'>
          <i className='bx bx-laugh' />
          <div className='label'>bx-laugh</div>
        </div>
        <div className='icon'>
          <i className='bx bx-layer' />
          <div className='label'>bx-layer</div>
        </div>
        <div className='icon'>
          <i className='bx bx-layer-minus' />
          <div className='label'>bx-layer-minus</div>
        </div>
        <div className='icon'>
          <i className='bx bx-layer-plus' />
          <div className='label'>bx-layer-plus</div>
        </div>
        <div className='icon'>
          <i className='bx bx-layout' />
          <div className='label'>bx-layout</div>
        </div>
        <div className='icon'>
          <i className='bx bx-left-arrow' />
          <div className='label'>bx-left-arrow</div>
        </div>
        <div className='icon'>
          <i className='bx bx-left-arrow-alt' />
          <div className='label'>bx-left-arrow-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bx-left-arrow-circle' />
          <div className='label'>bx-left-arrow-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bx-left-down-arrow-circle' />
          <div className='label'>bx-left-down-arrow-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bx-left-indent' />
          <div className='label'>bx-left-indent</div>
        </div>
        <div className='icon'>
          <i className='bx bx-left-top-arrow-circle' />
          <div className='label'>bx-left-top-arrow-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bx-library' />
          <div className='label'>bx-library</div>
        </div>
        <div className='icon'>
          <i className='bx bx-like' />
          <div className='label'>bx-like</div>
        </div>
        <div className='icon'>
          <i className='bx bx-line-chart' />
          <div className='label'>bx-line-chart</div>
        </div>
        <div className='icon'>
          <i className='bx bx-line-chart-down' />
          <div className='label'>bx-line-chart-down</div>
        </div>
        <div className='icon'>
          <i className='bx bx-link' />
          <div className='label'>bx-link</div>
        </div>
        <div className='icon'>
          <i className='bx bx-link-alt' />
          <div className='label'>bx-link-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bx-link-external' />
          <div className='label'>bx-link-external</div>
        </div>
        <div className='icon'>
          <i className='bx bx-lira' />
          <div className='label'>bx-lira</div>
        </div>
        <div className='icon'>
          <i className='bx bx-list-check' />
          <div className='label'>bx-list-check</div>
        </div>
        <div className='icon'>
          <i className='bx bx-list-minus' />
          <div className='label'>bx-list-minus</div>
        </div>
        <div className='icon'>
          <i className='bx bx-list-ol' />
          <div className='label'>bx-list-ol</div>
        </div>
        <div className='icon'>
          <i className='bx bx-list-plus' />
          <div className='label'>bx-list-plus</div>
        </div>
        <div className='icon'>
          <i className='bx bx-list-ul' />
          <div className='label'>bx-list-ul</div>
        </div>
        <div className='icon'>
          <i className='bx bx-loader' />
          <div className='label'>bx-loader</div>
        </div>
        <div className='icon'>
          <i className='bx bx-loader-alt' />
          <div className='label'>bx-loader-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bx-loader-circle' />
          <div className='label'>bx-loader-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bx-location-plus' />
          <div className='label'>bx-location-plus</div>
        </div>
        <div className='icon'>
          <i className='bx bx-lock' />
          <div className='label'>bx-lock</div>
        </div>
        <div className='icon'>
          <i className='bx bx-lock-alt' />
          <div className='label'>bx-lock-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bx-lock-open' />
          <div className='label'>bx-lock-open</div>
        </div>
        <div className='icon'>
          <i className='bx bx-lock-open-alt' />
          <div className='label'>bx-lock-open-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bx-log-in' />
          <div className='label'>bx-log-in</div>
        </div>
        <div className='icon'>
          <i className='bx bx-log-in-circle' />
          <div className='label'>bx-log-in-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bx-log-out' />
          <div className='label'>bx-log-out</div>
        </div>
        <div className='icon'>
          <i className='bx bx-log-out-circle' />
          <div className='label'>bx-log-out-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bx-low-vision' />
          <div className='label'>bx-low-vision</div>
        </div>
        <div className='icon'>
          <i className='bx bx-magnet' />
          <div className='label'>bx-magnet</div>
        </div>
        <div className='icon'>
          <i className='bx bx-mail-send' />
          <div className='label'>bx-mail-send</div>
        </div>
        <div className='icon'>
          <i className='bx bx-male' />
          <div className='label'>bx-male</div>
        </div>
        <div className='icon'>
          <i className='bx bx-male-sign' />
          <div className='label'>bx-male-sign</div>
        </div>
        <div className='icon'>
          <i className='bx bx-map' />
          <div className='label'>bx-map</div>
        </div>
        <div className='icon'>
          <i className='bx bx-map-alt' />
          <div className='label'>bx-map-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bx-map-pin' />
          <div className='label'>bx-map-pin</div>
        </div>
        <div className='icon'>
          <i className='bx bx-mask' />
          <div className='label'>bx-mask</div>
        </div>
        <div className='icon'>
          <i className='bx bx-medal' />
          <div className='label'>bx-medal</div>
        </div>
        <div className='icon'>
          <i className='bx bx-meh' />
          <div className='label'>bx-meh</div>
        </div>
        <div className='icon'>
          <i className='bx bx-meh-alt' />
          <div className='label'>bx-meh-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bx-meh-blank' />
          <div className='label'>bx-meh-blank</div>
        </div>
        <div className='icon'>
          <i className='bx bx-memory-card' />
          <div className='label'>bx-memory-card</div>
        </div>
        <div className='icon'>
          <i className='bx bx-menu' />
          <div className='label'>bx-menu</div>
        </div>
        <div className='icon'>
          <i className='bx bx-menu-alt-left' />
          <div className='label'>bx-menu-alt-left</div>
        </div>
        <div className='icon'>
          <i className='bx bx-menu-alt-right' />
          <div className='label'>bx-menu-alt-right</div>
        </div>
        <div className='icon'>
          <i className='bx bx-merge' />
          <div className='label'>bx-merge</div>
        </div>
        <div className='icon'>
          <i className='bx bx-message' />
          <div className='label'>bx-message</div>
        </div>
        <div className='icon'>
          <i className='bx bx-message-add' />
          <div className='label'>bx-message-add</div>
        </div>
        <div className='icon'>
          <i className='bx bx-message-alt' />
          <div className='label'>bx-message-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bx-message-alt-add' />
          <div className='label'>bx-message-alt-add</div>
        </div>
        <div className='icon'>
          <i className='bx bx-message-alt-check' />
          <div className='label'>bx-message-alt-check</div>
        </div>
        <div className='icon'>
          <i className='bx bx-message-alt-detail' />
          <div className='label'>bx-message-alt-detail</div>
        </div>
        <div className='icon'>
          <i className='bx bx-message-alt-dots' />
          <div className='label'>bx-message-alt-dots</div>
        </div>
        <div className='icon'>
          <i className='bx bx-message-alt-edit' />
          <div className='label'>bx-message-alt-edit</div>
        </div>
        <div className='icon'>
          <i className='bx bx-message-alt-error' />
          <div className='label'>bx-message-alt-error</div>
        </div>
        <div className='icon'>
          <i className='bx bx-message-alt-minus' />
          <div className='label'>bx-message-alt-minus</div>
        </div>
        <div className='icon'>
          <i className='bx bx-message-alt-x' />
          <div className='label'>bx-message-alt-x</div>
        </div>
        <div className='icon'>
          <i className='bx bx-message-check' />
          <div className='label'>bx-message-check</div>
        </div>
        <div className='icon'>
          <i className='bx bx-message-detail' />
          <div className='label'>bx-message-detail</div>
        </div>
        <div className='icon'>
          <i className='bx bx-message-dots' />
          <div className='label'>bx-message-dots</div>
        </div>
        <div className='icon'>
          <i className='bx bx-message-edit' />
          <div className='label'>bx-message-edit</div>
        </div>
        <div className='icon'>
          <i className='bx bx-message-error' />
          <div className='label'>bx-message-error</div>
        </div>
        <div className='icon'>
          <i className='bx bx-message-minus' />
          <div className='label'>bx-message-minus</div>
        </div>
        <div className='icon'>
          <i className='bx bx-message-rounded' />
          <div className='label'>bx-message-rounded</div>
        </div>
        <div className='icon'>
          <i className='bx bx-message-rounded-add' />
          <div className='label'>bx-message-rounded-add</div>
        </div>
        <div className='icon'>
          <i className='bx bx-message-rounded-check' />
          <div className='label'>bx-message-rounded-check</div>
        </div>
        <div className='icon'>
          <i className='bx bx-message-rounded-detail' />
          <div className='label'>bx-message-rounded-detail</div>
        </div>
        <div className='icon'>
          <i className='bx bx-message-rounded-dots' />
          <div className='label'>bx-message-rounded-dots</div>
        </div>
        <div className='icon'>
          <i className='bx bx-message-rounded-edit' />
          <div className='label'>bx-message-rounded-edit</div>
        </div>
        <div className='icon'>
          <i className='bx bx-message-rounded-error' />
          <div className='label'>bx-message-rounded-error</div>
        </div>
        <div className='icon'>
          <i className='bx bx-message-rounded-minus' />
          <div className='label'>bx-message-rounded-minus</div>
        </div>
        <div className='icon'>
          <i className='bx bx-message-rounded-x' />
          <div className='label'>bx-message-rounded-x</div>
        </div>
        <div className='icon'>
          <i className='bx bx-message-square' />
          <div className='label'>bx-message-square</div>
        </div>
        <div className='icon'>
          <i className='bx bx-message-square-add' />
          <div className='label'>bx-message-square-add</div>
        </div>
        <div className='icon'>
          <i className='bx bx-message-square-check' />
          <div className='label'>bx-message-square-check</div>
        </div>
        <div className='icon'>
          <i className='bx bx-message-square-detail' />
          <div className='label'>bx-message-square-detail</div>
        </div>
        <div className='icon'>
          <i className='bx bx-message-square-dots' />
          <div className='label'>bx-message-square-dots</div>
        </div>
        <div className='icon'>
          <i className='bx bx-message-square-edit' />
          <div className='label'>bx-message-square-edit</div>
        </div>
        <div className='icon'>
          <i className='bx bx-message-square-error' />
          <div className='label'>bx-message-square-error</div>
        </div>
        <div className='icon'>
          <i className='bx bx-message-square-minus' />
          <div className='label'>bx-message-square-minus</div>
        </div>
        <div className='icon'>
          <i className='bx bx-message-square-x' />
          <div className='label'>bx-message-square-x</div>
        </div>
        <div className='icon'>
          <i className='bx bx-message-x' />
          <div className='label'>bx-message-x</div>
        </div>
        <div className='icon'>
          <i className='bx bx-meteor' />
          <div className='label'>bx-meteor</div>
        </div>
        <div className='icon'>
          <i className='bx bx-microchip' />
          <div className='label'>bx-microchip</div>
        </div>
        <div className='icon'>
          <i className='bx bx-microphone' />
          <div className='label'>bx-microphone</div>
        </div>
        <div className='icon'>
          <i className='bx bx-microphone-off' />
          <div className='label'>bx-microphone-off</div>
        </div>
        <div className='icon'>
          <i className='bx bx-minus' />
          <div className='label'>bx-minus</div>
        </div>
        <div className='icon'>
          <i className='bx bx-minus-back' />
          <div className='label'>bx-minus-back</div>
        </div>
        <div className='icon'>
          <i className='bx bx-minus-circle' />
          <div className='label'>bx-minus-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bx-minus-front' />
          <div className='label'>bx-minus-front</div>
        </div>
        <div className='icon'>
          <i className='bx bx-mobile' />
          <div className='label'>bx-mobile</div>
        </div>
        <div className='icon'>
          <i className='bx bx-mobile-alt' />
          <div className='label'>bx-mobile-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bx-mobile-landscape' />
          <div className='label'>bx-mobile-landscape</div>
        </div>
        <div className='icon'>
          <i className='bx bx-mobile-vibration' />
          <div className='label'>bx-mobile-vibration</div>
        </div>
        <div className='icon'>
          <i className='bx bx-money' />
          <div className='label'>bx-money</div>
        </div>
        <div className='icon'>
          <i className='bx bx-moon' />
          <div className='label'>bx-moon</div>
        </div>
        <div className='icon'>
          <i className='bx bx-mouse' />
          <div className='label'>bx-mouse</div>
        </div>
        <div className='icon'>
          <i className='bx bx-mouse-alt' />
          <div className='label'>bx-mouse-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bx-move' />
          <div className='label'>bx-move</div>
        </div>
        <div className='icon'>
          <i className='bx bx-move-horizontal' />
          <div className='label'>bx-move-horizontal</div>
        </div>
        <div className='icon'>
          <i className='bx bx-move-vertical' />
          <div className='label'>bx-move-vertical</div>
        </div>
        <div className='icon'>
          <i className='bx bx-movie' />
          <div className='label'>bx-movie</div>
        </div>
        <div className='icon'>
          <i className='bx bx-movie-play' />
          <div className='label'>bx-movie-play</div>
        </div>
        <div className='icon'>
          <i className='bx bx-music' />
          <div className='label'>bx-music</div>
        </div>
        <div className='icon'>
          <i className='bx bx-navigation' />
          <div className='label'>bx-navigation</div>
        </div>
        <div className='icon'>
          <i className='bx bx-network-chart' />
          <div className='label'>bx-network-chart</div>
        </div>
        <div className='icon'>
          <i className='bx bx-news' />
          <div className='label'>bx-news</div>
        </div>
        <div className='icon'>
          <i className='bx bx-no-entry' />
          <div className='label'>bx-no-entry</div>
        </div>
        <div className='icon'>
          <i className='bx bx-note' />
          <div className='label'>bx-note</div>
        </div>
        <div className='icon'>
          <i className='bx bx-notepad' />
          <div className='label'>bx-notepad</div>
        </div>
        <div className='icon'>
          <i className='bx bx-notification' />
          <div className='label'>bx-notification</div>
        </div>
        <div className='icon'>
          <i className='bx bx-notification-off' />
          <div className='label'>bx-notification-off</div>
        </div>
        <div className='icon'>
          <i className='bx bx-outline' />
          <div className='label'>bx-outline</div>
        </div>
        <div className='icon'>
          <i className='bx bx-package' />
          <div className='label'>bx-package</div>
        </div>
        <div className='icon'>
          <i className='bx bx-paint' />
          <div className='label'>bx-paint</div>
        </div>
        <div className='icon'>
          <i className='bx bx-paint-roll' />
          <div className='label'>bx-paint-roll</div>
        </div>
        <div className='icon'>
          <i className='bx bx-palette' />
          <div className='label'>bx-palette</div>
        </div>
        <div className='icon'>
          <i className='bx bx-paperclip' />
          <div className='label'>bx-paperclip</div>
        </div>
        <div className='icon'>
          <i className='bx bx-paper-plane' />
          <div className='label'>bx-paper-plane</div>
        </div>
        <div className='icon'>
          <i className='bx bx-paragraph' />
          <div className='label'>bx-paragraph</div>
        </div>
        <div className='icon'>
          <i className='bx bx-paste' />
          <div className='label'>bx-paste</div>
        </div>
        <div className='icon'>
          <i className='bx bx-pause' />
          <div className='label'>bx-pause</div>
        </div>
        <div className='icon'>
          <i className='bx bx-pause-circle' />
          <div className='label'>bx-pause-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bx-pen' />
          <div className='label'>bx-pen</div>
        </div>
        <div className='icon'>
          <i className='bx bx-pencil' />
          <div className='label'>bx-pencil</div>
        </div>
        <div className='icon'>
          <i className='bx bx-phone' />
          <div className='label'>bx-phone</div>
        </div>
        <div className='icon'>
          <i className='bx bx-phone-call' />
          <div className='label'>bx-phone-call</div>
        </div>
        <div className='icon'>
          <i className='bx bx-phone-incoming' />
          <div className='label'>bx-phone-incoming</div>
        </div>
        <div className='icon'>
          <i className='bx bx-phone-off' />
          <div className='label'>bx-phone-off</div>
        </div>
        <div className='icon'>
          <i className='bx bx-phone-outgoing' />
          <div className='label'>bx-phone-outgoing</div>
        </div>
        <div className='icon'>
          <i className='bx bx-photo-album' />
          <div className='label'>bx-photo-album</div>
        </div>
        <div className='icon'>
          <i className='bx bx-pie-chart' />
          <div className='label'>bx-pie-chart</div>
        </div>
        <div className='icon'>
          <i className='bx bx-pie-chart-alt' />
          <div className='label'>bx-pie-chart-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bx-pie-chart-alt-2' />
          <div className='label'>bx-pie-chart-alt-2</div>
        </div>
        <div className='icon'>
          <i className='bx bx-pin' />
          <div className='label'>bx-pin</div>
        </div>
        <div className='icon'>
          <i className='bx bx-planet' />
          <div className='label'>bx-planet</div>
        </div>
        <div className='icon'>
          <i className='bx bx-play' />
          <div className='label'>bx-play</div>
        </div>
        <div className='icon'>
          <i className='bx bx-play-circle' />
          <div className='label'>bx-play-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bx-plug' />
          <div className='label'>bx-plug</div>
        </div>
        <div className='icon'>
          <i className='bx bx-plus' />
          <div className='label'>bx-plus</div>
        </div>
        <div className='icon'>
          <i className='bx bx-plus-circle' />
          <div className='label'>bx-plus-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bx-plus-medical' />
          <div className='label'>bx-plus-medical</div>
        </div>
        <div className='icon'>
          <i className='bx bx-podcast' />
          <div className='label'>bx-podcast</div>
        </div>
        <div className='icon'>
          <i className='bx bx-pointer' />
          <div className='label'>bx-pointer</div>
        </div>
        <div className='icon'>
          <i className='bx bx-poll' />
          <div className='label'>bx-poll</div>
        </div>
        <div className='icon'>
          <i className='bx bx-polygon' />
          <div className='label'>bx-polygon</div>
        </div>
        <div className='icon'>
          <i className='bx bx-pound' />
          <div className='label'>bx-pound</div>
        </div>
        <div className='icon'>
          <i className='bx bx-power-off' />
          <div className='label'>bx-power-off</div>
        </div>
        <div className='icon'>
          <i className='bx bx-printer' />
          <div className='label'>bx-printer</div>
        </div>
        <div className='icon'>
          <i className='bx bx-pulse' />
          <div className='label'>bx-pulse</div>
        </div>
        <div className='icon'>
          <i className='bx bx-purchase-tag' />
          <div className='label'>bx-purchase-tag</div>
        </div>
        <div className='icon'>
          <i className='bx bx-purchase-tag-alt' />
          <div className='label'>bx-purchase-tag-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bx-pyramid' />
          <div className='label'>bx-pyramid</div>
        </div>
        <div className='icon'>
          <i className='bx bx-qr' />
          <div className='label'>bx-qr</div>
        </div>
        <div className='icon'>
          <i className='bx bx-qr-scan' />
          <div className='label'>bx-qr-scan</div>
        </div>
        <div className='icon'>
          <i className='bx bx-question-mark' />
          <div className='label'>bx-question-mark</div>
        </div>
        <div className='icon'>
          <i className='bx bx-radar' />
          <div className='label'>bx-radar</div>
        </div>
        <div className='icon'>
          <i className='bx bx-radio' />
          <div className='label'>bx-radio</div>
        </div>
        <div className='icon'>
          <i className='bx bx-radio-circle' />
          <div className='label'>bx-radio-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bx-radio-circle-marked' />
          <div className='label'>bx-radio-circle-marked</div>
        </div>
        <div className='icon'>
          <i className='bx bx-receipt' />
          <div className='label'>bx-receipt</div>
        </div>
        <div className='icon'>
          <i className='bx bx-rectangle' />
          <div className='label'>bx-rectangle</div>
        </div>
        <div className='icon'>
          <i className='bx bx-recycle' />
          <div className='label'>bx-recycle</div>
        </div>
        <div className='icon'>
          <i className='bx bx-redo' />
          <div className='label'>bx-redo</div>
        </div>
        <div className='icon'>
          <i className='bx bx-refresh' />
          <div className='label'>bx-refresh</div>
        </div>
        <div className='icon'>
          <i className='bx bx-registered' />
          <div className='label'>bx-registered</div>
        </div>
        <div className='icon'>
          <i className='bx bx-rename' />
          <div className='label'>bx-rename</div>
        </div>
        <div className='icon'>
          <i className='bx bx-repeat' />
          <div className='label'>bx-repeat</div>
        </div>
        <div className='icon'>
          <i className='bx bx-reply' />
          <div className='label'>bx-reply</div>
        </div>
        <div className='icon'>
          <i className='bx bx-reply-all' />
          <div className='label'>bx-reply-all</div>
        </div>
        <div className='icon'>
          <i className='bx bx-repost' />
          <div className='label'>bx-repost</div>
        </div>
        <div className='icon'>
          <i className='bx bx-reset' />
          <div className='label'>bx-reset</div>
        </div>
        <div className='icon'>
          <i className='bx bx-restaurant' />
          <div className='label'>bx-restaurant</div>
        </div>
        <div className='icon'>
          <i className='bx bx-revision' />
          <div className='label'>bx-revision</div>
        </div>
        <div className='icon'>
          <i className='bx bx-rewind' />
          <div className='label'>bx-rewind</div>
        </div>
        <div className='icon'>
          <i className='bx bx-rewind-circle' />
          <div className='label'>bx-rewind-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bx-right-arrow' />
          <div className='label'>bx-right-arrow</div>
        </div>
        <div className='icon'>
          <i className='bx bx-right-arrow-alt' />
          <div className='label'>bx-right-arrow-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bx-right-arrow-circle' />
          <div className='label'>bx-right-arrow-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bx-right-down-arrow-circle' />
          <div className='label'>bx-right-down-arrow-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bx-right-indent' />
          <div className='label'>bx-right-indent</div>
        </div>
        <div className='icon'>
          <i className='bx bx-right-top-arrow-circle' />
          <div className='label'>bx-right-top-arrow-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bx-rocket' />
          <div className='label'>bx-rocket</div>
        </div>
        <div className='icon'>
          <i className='bx bx-rotate-left' />
          <div className='label'>bx-rotate-left</div>
        </div>
        <div className='icon'>
          <i className='bx bx-rotate-right' />
          <div className='label'>bx-rotate-right</div>
        </div>
        <div className='icon'>
          <i className='bx bx-rss' />
          <div className='label'>bx-rss</div>
        </div>
        <div className='icon'>
          <i className='bx bx-ruble' />
          <div className='label'>bx-ruble</div>
        </div>
        <div className='icon'>
          <i className='bx bx-ruler' />
          <div className='label'>bx-ruler</div>
        </div>
        <div className='icon'>
          <i className='bx bx-run' />
          <div className='label'>bx-run</div>
        </div>
        <div className='icon'>
          <i className='bx bx-rupee' />
          <div className='label'>bx-rupee</div>
        </div>
        <div className='icon'>
          <i className='bx bx-sad' />
          <div className='label'>bx-sad</div>
        </div>
        <div className='icon'>
          <i className='bx bx-save' />
          <div className='label'>bx-save</div>
        </div>
        <div className='icon'>
          <i className='bx bx-scan' />
          <div className='label'>bx-scan</div>
        </div>
        <div className='icon'>
          <i className='bx bx-screenshot' />
          <div className='label'>bx-screenshot</div>
        </div>
        <div className='icon'>
          <i className='bx bx-search' />
          <div className='label'>bx-search</div>
        </div>
        <div className='icon'>
          <i className='bx bx-search-alt' />
          <div className='label'>bx-search-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bx-search-alt-2' />
          <div className='label'>bx-search-alt-2</div>
        </div>
        <div className='icon'>
          <i className='bx bx-selection' />
          <div className='label'>bx-selection</div>
        </div>
        <div className='icon'>
          <i className='bx bx-select-multiple' />
          <div className='label'>bx-select-multiple</div>
        </div>
        <div className='icon'>
          <i className='bx bx-send' />
          <div className='label'>bx-send</div>
        </div>
        <div className='icon'>
          <i className='bx bx-server' />
          <div className='label'>bx-server</div>
        </div>
        <div className='icon'>
          <i className='bx bx-shape-circle' />
          <div className='label'>bx-shape-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bx-shape-polygon' />
          <div className='label'>bx-shape-polygon</div>
        </div>
        <div className='icon'>
          <i className='bx bx-shape-square' />
          <div className='label'>bx-shape-square</div>
        </div>
        <div className='icon'>
          <i className='bx bx-shape-triangle' />
          <div className='label'>bx-shape-triangle</div>
        </div>
        <div className='icon'>
          <i className='bx bx-share' />
          <div className='label'>bx-share</div>
        </div>
        <div className='icon'>
          <i className='bx bx-share-alt' />
          <div className='label'>bx-share-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bx-shekel' />
          <div className='label'>bx-shekel</div>
        </div>
        <div className='icon'>
          <i className='bx bx-shield' />
          <div className='label'>bx-shield</div>
        </div>
        <div className='icon'>
          <i className='bx bx-shield-alt' />
          <div className='label'>bx-shield-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bx-shield-alt-2' />
          <div className='label'>bx-shield-alt-2</div>
        </div>
        <div className='icon'>
          <i className='bx bx-shield-quarter' />
          <div className='label'>bx-shield-quarter</div>
        </div>
        <div className='icon'>
          <i className='bx bx-shield-x' />
          <div className='label'>bx-shield-x</div>
        </div>
        <div className='icon'>
          <i className='bx bx-shocked' />
          <div className='label'>bx-shocked</div>
        </div>
        <div className='icon'>
          <i className='bx bx-shopping-bag' />
          <div className='label'>bx-shopping-bag</div>
        </div>
        <div className='icon'>
          <i className='bx bx-show' />
          <div className='label'>bx-show</div>
        </div>
        <div className='icon'>
          <i className='bx bx-show-alt' />
          <div className='label'>bx-show-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bx-shuffle' />
          <div className='label'>bx-shuffle</div>
        </div>
        <div className='icon'>
          <i className='bx bx-sidebar' />
          <div className='label'>bx-sidebar</div>
        </div>
        <div className='icon'>
          <i className='bx bx-sitemap' />
          <div className='label'>bx-sitemap</div>
        </div>
        <div className='icon'>
          <i className='bx bx-skip-next' />
          <div className='label'>bx-skip-next</div>
        </div>
        <div className='icon'>
          <i className='bx bx-skip-next-circle' />
          <div className='label'>bx-skip-next-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bx-skip-previous' />
          <div className='label'>bx-skip-previous</div>
        </div>
        <div className='icon'>
          <i className='bx bx-skip-previous-circle' />
          <div className='label'>bx-skip-previous-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bx-sleepy' />
          <div className='label'>bx-sleepy</div>
        </div>
        <div className='icon'>
          <i className='bx bx-slider' />
          <div className='label'>bx-slider</div>
        </div>
        <div className='icon'>
          <i className='bx bx-slider-alt' />
          <div className='label'>bx-slider-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bx-slideshow' />
          <div className='label'>bx-slideshow</div>
        </div>
        <div className='icon'>
          <i className='bx bx-smile' />
          <div className='label'>bx-smile</div>
        </div>
        <div className='icon'>
          <i className='bx bx-sort' />
          <div className='label'>bx-sort</div>
        </div>
        <div className='icon'>
          <i className='bx bx-sort-alt-2' />
          <div className='label'>bx-sort-alt-2</div>
        </div>
        <div className='icon'>
          <i className='bx bx-sort-a-z' />
          <div className='label'>bx-sort-a-z</div>
        </div>
        <div className='icon'>
          <i className='bx bx-sort-down' />
          <div className='label'>bx-sort-down</div>
        </div>
        <div className='icon'>
          <i className='bx bx-sort-up' />
          <div className='label'>bx-sort-up</div>
        </div>
        <div className='icon'>
          <i className='bx bx-sort-z-a' />
          <div className='label'>bx-sort-z-a</div>
        </div>
        <div className='icon'>
          <i className='bx bx-spa' />
          <div className='label'>bx-spa</div>
        </div>
        <div className='icon'>
          <i className='bx bx-space-bar' />
          <div className='label'>bx-space-bar</div>
        </div>
        <div className='icon'>
          <i className='bx bx-speaker' />
          <div className='label'>bx-speaker</div>
        </div>
        <div className='icon'>
          <i className='bx bx-spray-can' />
          <div className='label'>bx-spray-can</div>
        </div>
        <div className='icon'>
          <i className='bx bx-spreadsheet' />
          <div className='label'>bx-spreadsheet</div>
        </div>
        <div className='icon'>
          <i className='bx bx-square' />
          <div className='label'>bx-square</div>
        </div>
        <div className='icon'>
          <i className='bx bx-square-rounded' />
          <div className='label'>bx-square-rounded</div>
        </div>
        <div className='icon'>
          <i className='bx bx-star' />
          <div className='label'>bx-star</div>
        </div>
        <div className='icon'>
          <i className='bx bx-station' />
          <div className='label'>bx-station</div>
        </div>
        <div className='icon'>
          <i className='bx bx-stats' />
          <div className='label'>bx-stats</div>
        </div>
        <div className='icon'>
          <i className='bx bx-sticker' />
          <div className='label'>bx-sticker</div>
        </div>
        <div className='icon'>
          <i className='bx bx-stop' />
          <div className='label'>bx-stop</div>
        </div>
        <div className='icon'>
          <i className='bx bx-stop-circle' />
          <div className='label'>bx-stop-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bx-stopwatch' />
          <div className='label'>bx-stopwatch</div>
        </div>
        <div className='icon'>
          <i className='bx bx-store' />
          <div className='label'>bx-store</div>
        </div>
        <div className='icon'>
          <i className='bx bx-store-alt' />
          <div className='label'>bx-store-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bx-street-view' />
          <div className='label'>bx-street-view</div>
        </div>
        <div className='icon'>
          <i className='bx bx-strikethrough' />
          <div className='label'>bx-strikethrough</div>
        </div>
        <div className='icon'>
          <i className='bx bx-subdirectory-left' />
          <div className='label'>bx-subdirectory-left</div>
        </div>
        <div className='icon'>
          <i className='bx bx-subdirectory-right' />
          <div className='label'>bx-subdirectory-right</div>
        </div>
        <div className='icon'>
          <i className='bx bx-sun' />
          <div className='label'>bx-sun</div>
        </div>
        <div className='icon'>
          <i className='bx bx-support' />
          <div className='label'>bx-support</div>
        </div>
        <div className='icon'>
          <i className='bx bx-swim' />
          <div className='label'>bx-swim</div>
        </div>
        <div className='icon'>
          <i className='bx bx-sync' />
          <div className='label'>bx-sync</div>
        </div>
        <div className='icon'>
          <i className='bx bx-tab' />
          <div className='label'>bx-tab</div>
        </div>
        <div className='icon'>
          <i className='bx bx-table' />
          <div className='label'>bx-table</div>
        </div>
        <div className='icon'>
          <i className='bx bx-tachometer' />
          <div className='label'>bx-tachometer</div>
        </div>
        <div className='icon'>
          <i className='bx bx-tag' />
          <div className='label'>bx-tag</div>
        </div>
        <div className='icon'>
          <i className='bx bx-tag-alt' />
          <div className='label'>bx-tag-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bx-target-lock' />
          <div className='label'>bx-target-lock</div>
        </div>
        <div className='icon'>
          <i className='bx bx-task' />
          <div className='label'>bx-task</div>
        </div>
        <div className='icon'>
          <i className='bx bx-task-x' />
          <div className='label'>bx-task-x</div>
        </div>
        <div className='icon'>
          <i className='bx bx-taxi' />
          <div className='label'>bx-taxi</div>
        </div>
        <div className='icon'>
          <i className='bx bx-tennis-ball' />
          <div className='label'>bx-tennis-ball</div>
        </div>
        <div className='icon'>
          <i className='bx bx-terminal' />
          <div className='label'>bx-terminal</div>
        </div>
        <div className='icon'>
          <i className='bx bx-test-tube' />
          <div className='label'>bx-test-tube</div>
        </div>
        <div className='icon'>
          <i className='bx bx-text' />
          <div className='label'>bx-text</div>
        </div>
        <div className='icon'>
          <i className='bx bx-time' />
          <div className='label'>bx-time</div>
        </div>
        <div className='icon'>
          <i className='bx bx-time-five' />
          <div className='label'>bx-time-five</div>
        </div>
        <div className='icon'>
          <i className='bx bx-timer' />
          <div className='label'>bx-timer</div>
        </div>
        <div className='icon'>
          <i className='bx bx-tired' />
          <div className='label'>bx-tired</div>
        </div>
        <div className='icon'>
          <i className='bx bx-toggle-left' />
          <div className='label'>bx-toggle-left</div>
        </div>
        <div className='icon'>
          <i className='bx bx-toggle-right' />
          <div className='label'>bx-toggle-right</div>
        </div>
        <div className='icon'>
          <i className='bx bx-tone' />
          <div className='label'>bx-tone</div>
        </div>
        <div className='icon'>
          <i className='bx bx-traffic-cone' />
          <div className='label'>bx-traffic-cone</div>
        </div>
        <div className='icon'>
          <i className='bx bx-train' />
          <div className='label'>bx-train</div>
        </div>
        <div className='icon'>
          <i className='bx bx-transfer' />
          <div className='label'>bx-transfer</div>
        </div>
        <div className='icon'>
          <i className='bx bx-transfer-alt' />
          <div className='label'>bx-transfer-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bx-trash' />
          <div className='label'>bx-trash</div>
        </div>
        <div className='icon'>
          <i className='bx bx-trash-alt' />
          <div className='label'>bx-trash-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bx-trending-down' />
          <div className='label'>bx-trending-down</div>
        </div>
        <div className='icon'>
          <i className='bx bx-trending-up' />
          <div className='label'>bx-trending-up</div>
        </div>
        <div className='icon'>
          <i className='bx bx-trim' />
          <div className='label'>bx-trim</div>
        </div>
        <div className='icon'>
          <i className='bx bx-trip' />
          <div className='label'>bx-trip</div>
        </div>
        <div className='icon'>
          <i className='bx bx-trophy' />
          <div className='label'>bx-trophy</div>
        </div>
        <div className='icon'>
          <i className='bx bx-tv' />
          <div className='label'>bx-tv</div>
        </div>
        <div className='icon'>
          <i className='bx bx-underline' />
          <div className='label'>bx-underline</div>
        </div>
        <div className='icon'>
          <i className='bx bx-undo' />
          <div className='label'>bx-undo</div>
        </div>
        <div className='icon'>
          <i className='bx bx-unite' />
          <div className='label'>bx-unite</div>
        </div>
        <div className='icon'>
          <i className='bx bx-unlink' />
          <div className='label'>bx-unlink</div>
        </div>
        <div className='icon'>
          <i className='bx bx-up-arrow' />
          <div className='label'>bx-up-arrow</div>
        </div>
        <div className='icon'>
          <i className='bx bx-up-arrow-alt' />
          <div className='label'>bx-up-arrow-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bx-up-arrow-circle' />
          <div className='label'>bx-up-arrow-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bx-upload' />
          <div className='label'>bx-upload</div>
        </div>
        <div className='icon'>
          <i className='bx bx-upside-down' />
          <div className='label'>bx-upside-down</div>
        </div>
        <div className='icon'>
          <i className='bx bx-upvote' />
          <div className='label'>bx-upvote</div>
        </div>
        <div className='icon'>
          <i className='bx bx-usb' />
          <div className='label'>bx-usb</div>
        </div>
        <div className='icon'>
          <i className='bx bx-user' />
          <div className='label'>bx-user</div>
        </div>
        <div className='icon'>
          <i className='bx bx-user-check' />
          <div className='label'>bx-user-check</div>
        </div>
        <div className='icon'>
          <i className='bx bx-user-circle' />
          <div className='label'>bx-user-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bx-user-minus' />
          <div className='label'>bx-user-minus</div>
        </div>
        <div className='icon'>
          <i className='bx bx-user-pin' />
          <div className='label'>bx-user-pin</div>
        </div>
        <div className='icon'>
          <i className='bx bx-user-plus' />
          <div className='label'>bx-user-plus</div>
        </div>
        <div className='icon'>
          <i className='bx bx-user-voice' />
          <div className='label'>bx-user-voice</div>
        </div>
        <div className='icon'>
          <i className='bx bx-user-x' />
          <div className='label'>bx-user-x</div>
        </div>
        <div className='icon'>
          <i className='bx bx-vector' />
          <div className='label'>bx-vector</div>
        </div>
        <div className='icon'>
          <i className='bx bx-vertical-center' />
          <div className='label'>bx-vertical-center</div>
        </div>
        <div className='icon'>
          <i className='bx bx-vial' />
          <div className='label'>bx-vial</div>
        </div>
        <div className='icon'>
          <i className='bx bx-video' />
          <div className='label'>bx-video</div>
        </div>
        <div className='icon'>
          <i className='bx bx-video-off' />
          <div className='label'>bx-video-off</div>
        </div>
        <div className='icon'>
          <i className='bx bx-video-plus' />
          <div className='label'>bx-video-plus</div>
        </div>
        <div className='icon'>
          <i className='bx bx-video-recording' />
          <div className='label'>bx-video-recording</div>
        </div>
        <div className='icon'>
          <i className='bx bx-voicemail' />
          <div className='label'>bx-voicemail</div>
        </div>
        <div className='icon'>
          <i className='bx bx-volume' />
          <div className='label'>bx-volume</div>
        </div>
        <div className='icon'>
          <i className='bx bx-volume-full' />
          <div className='label'>bx-volume-full</div>
        </div>
        <div className='icon'>
          <i className='bx bx-volume-low' />
          <div className='label'>bx-volume-low</div>
        </div>
        <div className='icon'>
          <i className='bx bx-volume-mute' />
          <div className='label'>bx-volume-mute</div>
        </div>
        <div className='icon'>
          <i className='bx bx-walk' />
          <div className='label'>bx-walk</div>
        </div>
        <div className='icon'>
          <i className='bx bx-wallet' />
          <div className='label'>bx-wallet</div>
        </div>
        <div className='icon'>
          <i className='bx bx-wallet-alt' />
          <div className='label'>bx-wallet-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bx-water' />
          <div className='label'>bx-water</div>
        </div>
        <div className='icon'>
          <i className='bx bx-webcam' />
          <div className='label'>bx-webcam</div>
        </div>
        <div className='icon'>
          <i className='bx bx-wifi' />
          <div className='label'>bx-wifi</div>
        </div>
        <div className='icon'>
          <i className='bx bx-wifi-0' />
          <div className='label'>bx-wifi-0</div>
        </div>
        <div className='icon'>
          <i className='bx bx-wifi-1' />
          <div className='label'>bx-wifi-1</div>
        </div>
        <div className='icon'>
          <i className='bx bx-wifi-2' />
          <div className='label'>bx-wifi-2</div>
        </div>
        <div className='icon'>
          <i className='bx bx-wifi-off' />
          <div className='label'>bx-wifi-off</div>
        </div>
        <div className='icon'>
          <i className='bx bx-wind' />
          <div className='label'>bx-wind</div>
        </div>
        <div className='icon'>
          <i className='bx bx-window' />
          <div className='label'>bx-window</div>
        </div>
        <div className='icon'>
          <i className='bx bx-window-alt' />
          <div className='label'>bx-window-alt</div>
        </div>
        <div className='icon'>
          <i className='bx bx-window-close' />
          <div className='label'>bx-window-close</div>
        </div>
        <div className='icon'>
          <i className='bx bx-window-open' />
          <div className='label'>bx-window-open</div>
        </div>
        <div className='icon'>
          <i className='bx bx-windows' />
          <div className='label'>bx-windows</div>
        </div>
        <div className='icon'>
          <i className='bx bx-wine' />
          <div className='label'>bx-wine</div>
        </div>
        <div className='icon'>
          <i className='bx bx-wink-smile' />
          <div className='label'>bx-wink-smile</div>
        </div>
        <div className='icon'>
          <i className='bx bx-wink-tongue' />
          <div className='label'>bx-wink-tongue</div>
        </div>
        <div className='icon'>
          <i className='bx bx-won' />
          <div className='label'>bx-won</div>
        </div>
        <div className='icon'>
          <i className='bx bx-world' />
          <div className='label'>bx-world</div>
        </div>
        <div className='icon'>
          <i className='bx bx-wrench' />
          <div className='label'>bx-wrench</div>
        </div>
        <div className='icon'>
          <i className='bx bx-x' />
          <div className='label'>bx-x</div>
        </div>
        <div className='icon'>
          <i className='bx bx-x-circle' />
          <div className='label'>bx-x-circle</div>
        </div>
        <div className='icon'>
          <i className='bx bx-yen' />
          <div className='label'>bx-yen</div>
        </div>
        <div className='icon'>
          <i className='bx bx-zoom-in' />
          <div className='label'>bx-zoom-in</div>
        </div>
        <div className='icon'>
          <i className='bx bx-zoom-out' />
          <div className='label'>bx-zoom-out</div>
        </div>
      </div>
    </section>
  );
};

export default BoxiconsInner;
